// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import { exportsParticipantsExportMultipleRetrieveResponseTransformer, exportsParticipantsExportRetrieveResponseTransformer, gestionnaireMeetingsListResponseTransformer, gestionnaireMeetingsMyParticipationRetrieveResponseTransformer, gestionnaireMeetingsMyScopeListListResponseTransformer, gestionnaireMeetingsPartialUpdateResponseTransformer, gestionnaireMeetingsRetrieveResponseTransformer, gestionnaireMeetingsSyncAvisTagadaCreateResponseTransformer, gestionnaireMeetingsSyncParticipantsTagadaCreateResponseTransformer, gestionnaireMeetingsUpdateResponseTransformer, gestionnaireParticipantsListResponseTransformer, gestionnaireParticipantsPartialUpdateResponseTransformer, gestionnaireParticipantsRetrieveResponseTransformer, gestionnaireParticipantsUpdateResponseTransformer, mediaRetrieveResponseTransformer, meetingsDailyTaskTeamsTeamDailyTasksListResponseTransformer, meetingsDailyTaskTeamsTeamDailyTasksRetrieveResponseTransformer, meetingsEventsApplyTypicalDayCreateResponseTransformer, meetingsEventsChildrenCreateResponseTransformer, meetingsEventsChildrenRetrieveResponseTransformer, meetingsEventsCopyToDaysCreateResponseTransformer, meetingsEventsCreateResponseTransformer, meetingsEventsEnrollmentCreateResponseTransformer, meetingsEventsEnrollmentListResponseTransformer, meetingsEventsEnrollmentsListResponseTransformer, meetingsEventsInChargeListResponseTransformer, meetingsEventsListResponseTransformer, meetingsEventsModularListResponseTransformer, meetingsEventsMyDailyEventsListResponseTransformer, meetingsEventsMyEnrollmentCreateResponseTransformer, meetingsEventsMyEnrollmentRetrieveResponseTransformer, meetingsEventsMyEnrollmentsListResponseTransformer, meetingsEventsOwnPlanningListResponseTransformer, meetingsEventsPartialUpdateResponseTransformer, meetingsEventsPlanningRetrieveResponseTransformer, meetingsEventsPublicListListResponseTransformer, meetingsEventsPublicModularListResponseTransformer, meetingsEventsRetrieveResponseTransformer, meetingsEventsSupervisorListResponseTransformer, meetingsEventsTypicalDayListResponseTransformer, meetingsEventsUpdateResponseTransformer, meetingsEventsWithActivityApplyTypicalDayCreateResponseTransformer, meetingsEventsWithActivityChildrenCreateResponseTransformer, meetingsEventsWithActivityChildrenRetrieveResponseTransformer, meetingsEventsWithActivityCopyToDaysCreateResponseTransformer, meetingsEventsWithActivityCreateResponseTransformer, meetingsEventsWithActivityEnrollmentCreateResponseTransformer, meetingsEventsWithActivityEnrollmentListResponseTransformer, meetingsEventsWithActivityEnrollmentsListResponseTransformer, meetingsEventsWithActivityInChargeListResponseTransformer, meetingsEventsWithActivityListResponseTransformer, meetingsEventsWithActivityMyDailyEventsListResponseTransformer, meetingsEventsWithActivityMyEnrollmentCreateResponseTransformer, meetingsEventsWithActivityMyEnrollmentRetrieveResponseTransformer, meetingsEventsWithActivityMyEnrollmentsListResponseTransformer, meetingsEventsWithActivityOwnPlanningListResponseTransformer, meetingsEventsWithActivityPartialUpdateResponseTransformer, meetingsEventsWithActivityPlanningRetrieveResponseTransformer, meetingsEventsWithActivityPublicListListResponseTransformer, meetingsEventsWithActivityRetrieveResponseTransformer, meetingsEventsWithActivitySupervisorListResponseTransformer, meetingsEventsWithActivityTypicalDayListResponseTransformer, meetingsEventsWithActivityUpdateResponseTransformer, meetingsFormsCreateResponseTransformer, meetingsFormsExportSubmissionsRetrieveResponseTransformer, meetingsFormsListResponseTransformer, meetingsFormsPartialUpdateResponseTransformer, meetingsFormsPublicListResponseTransformer, meetingsFormsPublicRetrieveResponseTransformer, meetingsFormsPublishCreateResponseTransformer, meetingsFormsRetrieveResponseTransformer, meetingsFormsSubmissionsCreateResponseTransformer, meetingsFormsSubmissionsListResponseTransformer, meetingsFormsSubmissionsPartialUpdateResponseTransformer, meetingsFormsSubmissionsRetrieveResponseTransformer, meetingsFormsSubmissionsUpdateResponseTransformer, meetingsFormsUpdateResponseTransformer, meetingsListResponseTransformer, meetingsMyParticipationRetrieveResponseTransformer, meetingsParticipantsAvatarMediaRetrieveResponseTransformer, meetingsParticipantsAvatarMediaUpdateResponseTransformer, meetingsParticipantsCommentsCreateResponseTransformer, meetingsParticipantsCommentsListResponseTransformer, meetingsParticipantsCommentsPartialUpdateResponseTransformer, meetingsParticipantsCommentsRetrieveResponseTransformer, meetingsParticipantsCommentsUpdateResponseTransformer, meetingsParticipantsListResponseTransformer, meetingsParticipantsOpinionListListResponseTransformer, meetingsParticipantsOpinionPartialUpdateResponseTransformer, meetingsParticipantsOpinionRetrieveResponseTransformer, meetingsParticipantsOpinionUpdateResponseTransformer, meetingsParticipantsPartialUpdateResponseTransformer, meetingsParticipantsRetrieveResponseTransformer, meetingsParticipantsSignatureMediaRetrieveResponseTransformer, meetingsParticipantsSignatureMediaUpdateResponseTransformer, meetingsParticipantsUpdateResponseTransformer, meetingsPublicListResponseTransformer, meetingsPublicRetrieveResponseTransformer, meetingsResourcesCreateResponseTransformer, meetingsResourcesPartialUpdateResponseTransformer, meetingsResourcesPublicCreateResponseTransformer, meetingsResourcesPublicPartialUpdateResponseTransformer, meetingsResourcesPublicResourceMediaRetrieveResponseTransformer, meetingsResourcesPublicResourceMediaUpdateResponseTransformer, meetingsResourcesPublicRetrieveResponseTransformer, meetingsResourcesPublicTreeRetrieveResponseTransformer, meetingsResourcesPublicUpdateResponseTransformer, meetingsResourcesResourceMediaRetrieveResponseTransformer, meetingsResourcesResourceMediaUpdateResponseTransformer, meetingsResourcesRetrieveResponseTransformer, meetingsResourcesTreeRetrieveResponseTransformer, meetingsResourcesUpdateResponseTransformer, meetingsRetrieveResponseTransformer, meetingsSyncAvisTagadaCreateResponseTransformer, meetingsSyncParticipantsTagadaCreateResponseTransformer, meetingsTableExportsParticipantListDirectionRetrieveResponseTransformer, meetingsTableExportsParticipantListRetrieveResponseTransformer, meetingsTableExportsProcesVerbalRetrieveResponseTransformer, meetingsTableExportsTeamsdailytasksbytaskRetrieveResponseTransformer, meetingsTableExportsTeamsdailytasksbyteamRetrieveResponseTransformer, meetingsTeamDailyTasksCreateResponseTransformer, meetingsTeamDailyTasksListResponseTransformer, meetingsTeamDailyTasksPartialUpdateResponseTransformer, meetingsTeamDailyTasksRetrieveResponseTransformer, meetingsTeamDailyTasksUpdateResponseTransformer, participantsExportsProcesVerbalRetrieveResponseTransformer, usersAvatarMediaRetrieveResponseTransformer, usersAvatarMediaUpdateResponseTransformer, usersDiplomasCreateResponseTransformer, usersDiplomasDiplomaMediaRetrieveResponseTransformer, usersDiplomasDiplomaMediaUpdateResponseTransformer, usersDiplomasListResponseTransformer, usersDiplomasPartialUpdateResponseTransformer, usersDiplomasRetrieveResponseTransformer, usersDiplomasUpdateResponseTransformer, usersMeRetrieveResponseTransformer, usersRetrieveResponseTransformer, usersSignatureMediaRetrieveResponseTransformer, usersSignatureMediaUpdateResponseTransformer, webhooksCronMeetingCreateResponseTransformer, webhooksCronMeetingParticipantCreateResponseTransformer } from './transformers.gen';
import type { AuthJwtCreateCreateData, AuthJwtCreateCreateResponses, AuthJwtRefreshCreateData, AuthJwtRefreshCreateResponses, AuthJwtVerifyCreateData, AuthJwtVerifyCreateResponses, AuthOCreateData, AuthOCreateResponses, AuthORetrieveData, AuthORetrieveResponses, AuthUsersActivationCreateData, AuthUsersActivationCreateResponses, AuthUsersCreateData, AuthUsersCreateResponses, AuthUsersDestroyData, AuthUsersDestroyResponses, AuthUsersListData, AuthUsersListResponses, AuthUsersMeDestroyData, AuthUsersMeDestroyResponses, AuthUsersMePartialUpdateData, AuthUsersMePartialUpdateResponses, AuthUsersMeRetrieveData, AuthUsersMeRetrieveResponses, AuthUsersMeUpdateData, AuthUsersMeUpdateResponses, AuthUsersPartialUpdateData, AuthUsersPartialUpdateResponses, AuthUsersResendActivationCreateData, AuthUsersResendActivationCreateResponses, AuthUsersResetPasswordConfirmCreateData, AuthUsersResetPasswordConfirmCreateResponses, AuthUsersResetPasswordCreateData, AuthUsersResetPasswordCreateResponses, AuthUsersResetUsernameConfirmCreateData, AuthUsersResetUsernameConfirmCreateResponses, AuthUsersResetUsernameCreateData, AuthUsersResetUsernameCreateResponses, AuthUsersRetrieveData, AuthUsersRetrieveResponses, AuthUsersSetPasswordCreateData, AuthUsersSetPasswordCreateResponses, AuthUsersSetUsernameCreateData, AuthUsersSetUsernameCreateResponses, AuthUsersUpdateData, AuthUsersUpdateResponses, ExportsCreateData, ExportsCreateResponses, ExportsDestroyData, ExportsDestroyResponses, ExportsListData, ExportsListResponses, ExportsPartialUpdateData, ExportsPartialUpdateResponses, ExportsParticipantsExportMultipleRetrieveData, ExportsParticipantsExportMultipleRetrieveResponses, ExportsParticipantsExportRetrieveData, ExportsParticipantsExportRetrieveResponses, ExportsRetrieveData, ExportsRetrieveResponses, ExportsUpdateData, ExportsUpdateResponses, GestionnaireMeetingsListData, GestionnaireMeetingsListResponses, GestionnaireMeetingsMyParticipationPartialUpdateData, GestionnaireMeetingsMyParticipationPartialUpdateResponses, GestionnaireMeetingsMyParticipationRetrieveData, GestionnaireMeetingsMyParticipationRetrieveResponses, GestionnaireMeetingsMyParticipationUpdateData, GestionnaireMeetingsMyParticipationUpdateResponses, GestionnaireMeetingsMyScopeListListData, GestionnaireMeetingsMyScopeListListResponses, GestionnaireMeetingsPartialUpdateData, GestionnaireMeetingsPartialUpdateResponses, GestionnaireMeetingsRequestAnonymizationPartialUpdateData, GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses, GestionnaireMeetingsResetParticipantsAvatarDestroyData, GestionnaireMeetingsResetParticipantsAvatarDestroyResponses, GestionnaireMeetingsResetParticipantsSignatureDestroyData, GestionnaireMeetingsResetParticipantsSignatureDestroyResponses, GestionnaireMeetingsRetrieveData, GestionnaireMeetingsRetrieveResponses, GestionnaireMeetingsRetrieveTagadaCandidateRetrieveData, GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses, GestionnaireMeetingsSyncAvisTagadaCreateData, GestionnaireMeetingsSyncAvisTagadaCreateResponses, GestionnaireMeetingsSyncFromIntranetCreateData, GestionnaireMeetingsSyncFromIntranetCreateResponses, GestionnaireMeetingsSyncParticipantsTagadaCreateData, GestionnaireMeetingsSyncParticipantsTagadaCreateResponses, GestionnaireMeetingsUpdateData, GestionnaireMeetingsUpdateResponses, GestionnaireParticipantsListData, GestionnaireParticipantsListResponses, GestionnaireParticipantsPartialUpdateData, GestionnaireParticipantsPartialUpdateResponses, GestionnaireParticipantsRetrieveData, GestionnaireParticipantsRetrieveResponses, GestionnaireParticipantsUpdateData, GestionnaireParticipantsUpdateResponses, MediaFileRetrieveData, MediaFileRetrieveResponses, MediaFileUpdateData, MediaFileUpdateResponses, MediaRetrieveData, MediaRetrieveResponses, MeetingModulesListData, MeetingModulesListResponses, MeetingModulesRetrieveData, MeetingModulesRetrieveResponses, MeetingRolesListData, MeetingRolesListResponses, MeetingRolesRetrieveData, MeetingRolesRetrieveResponses, MeetingsActivitiesCreateData, MeetingsActivitiesCreateResponses, MeetingsActivitiesDestroyData, MeetingsActivitiesDestroyResponses, MeetingsActivitiesListData, MeetingsActivitiesListResponses, MeetingsActivitiesPartialUpdateData, MeetingsActivitiesPartialUpdateResponses, MeetingsActivitiesRetrieveData, MeetingsActivitiesRetrieveResponses, MeetingsActivitiesUpdateData, MeetingsActivitiesUpdateResponses, MeetingsActivityCategoriesCreateData, MeetingsActivityCategoriesCreateResponses, MeetingsActivityCategoriesDestroyData, MeetingsActivityCategoriesDestroyResponses, MeetingsActivityCategoriesListData, MeetingsActivityCategoriesListResponses, MeetingsActivityCategoriesPartialUpdateData, MeetingsActivityCategoriesPartialUpdateResponses, MeetingsActivityCategoriesRetrieveData, MeetingsActivityCategoriesRetrieveResponses, MeetingsActivityCategoriesUpdateData, MeetingsActivityCategoriesUpdateResponses, MeetingsActivityTopicsCreateData, MeetingsActivityTopicsCreateResponses, MeetingsActivityTopicsDestroyData, MeetingsActivityTopicsDestroyResponses, MeetingsActivityTopicsListData, MeetingsActivityTopicsListResponses, MeetingsActivityTopicsPartialUpdateData, MeetingsActivityTopicsPartialUpdateResponses, MeetingsActivityTopicsRetrieveData, MeetingsActivityTopicsRetrieveResponses, MeetingsActivityTopicsUpdateData, MeetingsActivityTopicsUpdateResponses, MeetingsCommentTagsCreateData, MeetingsCommentTagsCreateResponses, MeetingsCommentTagsDestroyData, MeetingsCommentTagsDestroyResponses, MeetingsCommentTagsListData, MeetingsCommentTagsListResponses, MeetingsCommentTagsPartialUpdateData, MeetingsCommentTagsPartialUpdateResponses, MeetingsCommentTagsRetrieveData, MeetingsCommentTagsRetrieveResponses, MeetingsCommentTagsUpdateData, MeetingsCommentTagsUpdateResponses, MeetingsDailyTasksCreateData, MeetingsDailyTasksCreateResponses, MeetingsDailyTasksDestroyData, MeetingsDailyTasksDestroyResponses, MeetingsDailyTasksListData, MeetingsDailyTasksListResponses, MeetingsDailyTasksMyDailyTasksListData, MeetingsDailyTasksMyDailyTasksListResponses, MeetingsDailyTasksPartialUpdateData, MeetingsDailyTasksPartialUpdateResponses, MeetingsDailyTasksRetrieveData, MeetingsDailyTasksRetrieveResponses, MeetingsDailyTasksUpdateData, MeetingsDailyTasksUpdateResponses, MeetingsDailyTaskTeamsCreateData, MeetingsDailyTaskTeamsCreateResponses, MeetingsDailyTaskTeamsDestroyData, MeetingsDailyTaskTeamsDestroyResponses, MeetingsDailyTaskTeamsListData, MeetingsDailyTaskTeamsListResponses, MeetingsDailyTaskTeamsPartialUpdateData, MeetingsDailyTaskTeamsPartialUpdateResponses, MeetingsDailyTaskTeamsParticipantsRetrieveData, MeetingsDailyTaskTeamsParticipantsRetrieveResponses, MeetingsDailyTaskTeamsParticipantsUpdateData, MeetingsDailyTaskTeamsParticipantsUpdateResponses, MeetingsDailyTaskTeamsRetrieveData, MeetingsDailyTaskTeamsRetrieveResponses, MeetingsDailyTaskTeamsTeamDailyTasksListData, MeetingsDailyTaskTeamsTeamDailyTasksListResponses, MeetingsDailyTaskTeamsTeamDailyTasksRetrieveData, MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses, MeetingsDailyTaskTeamsUpdateData, MeetingsDailyTaskTeamsUpdateResponses, MeetingsEventsApplyTypicalDayCreateData, MeetingsEventsApplyTypicalDayCreateResponses, MeetingsEventsChildrenCreateData, MeetingsEventsChildrenCreateResponses, MeetingsEventsChildrenRetrieveData, MeetingsEventsChildrenRetrieveResponses, MeetingsEventsCopyToDaysCreateData, MeetingsEventsCopyToDaysCreateResponses, MeetingsEventsCreateData, MeetingsEventsCreateResponses, MeetingsEventsDestroyData, MeetingsEventsDestroyResponses, MeetingsEventsEnrollmentCreateData, MeetingsEventsEnrollmentCreateResponses, MeetingsEventsEnrollmentDestroyData, MeetingsEventsEnrollmentDestroyResponses, MeetingsEventsEnrollmentListData, MeetingsEventsEnrollmentListResponses, MeetingsEventsEnrollmentsListData, MeetingsEventsEnrollmentsListResponses, MeetingsEventsExportIcsRetrieve2Data, MeetingsEventsExportIcsRetrieve2Responses, MeetingsEventsExportIcsRetrieveData, MeetingsEventsExportIcsRetrieveResponses, MeetingsEventsInChargeListData, MeetingsEventsInChargeListResponses, MeetingsEventsListData, MeetingsEventsListResponses, MeetingsEventsModularListData, MeetingsEventsModularListResponses, MeetingsEventsMyDailyEventsListData, MeetingsEventsMyDailyEventsListResponses, MeetingsEventsMyEnrollmentCreateData, MeetingsEventsMyEnrollmentCreateResponses, MeetingsEventsMyEnrollmentDestroyData, MeetingsEventsMyEnrollmentDestroyResponses, MeetingsEventsMyEnrollmentRetrieveData, MeetingsEventsMyEnrollmentRetrieveResponses, MeetingsEventsMyEnrollmentsListData, MeetingsEventsMyEnrollmentsListResponses, MeetingsEventsOwnPlanningListData, MeetingsEventsOwnPlanningListResponses, MeetingsEventsPartialUpdateData, MeetingsEventsPartialUpdateResponses, MeetingsEventsPlanningRetrieveData, MeetingsEventsPlanningRetrieveResponses, MeetingsEventsPublicListListData, MeetingsEventsPublicListListResponses, MeetingsEventsPublicModularListData, MeetingsEventsPublicModularListResponses, MeetingsEventsRetrieveData, MeetingsEventsRetrieveResponses, MeetingsEventsSupervisorListData, MeetingsEventsSupervisorListResponses, MeetingsEventsTypicalDayListData, MeetingsEventsTypicalDayListResponses, MeetingsEventsUpdateData, MeetingsEventsUpdateResponses, MeetingsEventsWithActivityApplyTypicalDayCreateData, MeetingsEventsWithActivityApplyTypicalDayCreateResponses, MeetingsEventsWithActivityChildrenCreateData, MeetingsEventsWithActivityChildrenCreateResponses, MeetingsEventsWithActivityChildrenRetrieveData, MeetingsEventsWithActivityChildrenRetrieveResponses, MeetingsEventsWithActivityCopyToDaysCreateData, MeetingsEventsWithActivityCopyToDaysCreateResponses, MeetingsEventsWithActivityCreateData, MeetingsEventsWithActivityCreateResponses, MeetingsEventsWithActivityDestroyData, MeetingsEventsWithActivityDestroyResponses, MeetingsEventsWithActivityEnrollmentCreateData, MeetingsEventsWithActivityEnrollmentCreateResponses, MeetingsEventsWithActivityEnrollmentDestroyData, MeetingsEventsWithActivityEnrollmentDestroyResponses, MeetingsEventsWithActivityEnrollmentListData, MeetingsEventsWithActivityEnrollmentListResponses, MeetingsEventsWithActivityEnrollmentsListData, MeetingsEventsWithActivityEnrollmentsListResponses, MeetingsEventsWithActivityInChargeListData, MeetingsEventsWithActivityInChargeListResponses, MeetingsEventsWithActivityListData, MeetingsEventsWithActivityListResponses, MeetingsEventsWithActivityMyDailyEventsListData, MeetingsEventsWithActivityMyDailyEventsListResponses, MeetingsEventsWithActivityMyEnrollmentCreateData, MeetingsEventsWithActivityMyEnrollmentCreateResponses, MeetingsEventsWithActivityMyEnrollmentDestroyData, MeetingsEventsWithActivityMyEnrollmentDestroyResponses, MeetingsEventsWithActivityMyEnrollmentRetrieveData, MeetingsEventsWithActivityMyEnrollmentRetrieveResponses, MeetingsEventsWithActivityMyEnrollmentsListData, MeetingsEventsWithActivityMyEnrollmentsListResponses, MeetingsEventsWithActivityOwnPlanningListData, MeetingsEventsWithActivityOwnPlanningListResponses, MeetingsEventsWithActivityPartialUpdateData, MeetingsEventsWithActivityPartialUpdateResponses, MeetingsEventsWithActivityPlanningRetrieveData, MeetingsEventsWithActivityPlanningRetrieveResponses, MeetingsEventsWithActivityPublicListListData, MeetingsEventsWithActivityPublicListListResponses, MeetingsEventsWithActivityRetrieveData, MeetingsEventsWithActivityRetrieveResponses, MeetingsEventsWithActivitySupervisorListData, MeetingsEventsWithActivitySupervisorListResponses, MeetingsEventsWithActivityTypicalDayListData, MeetingsEventsWithActivityTypicalDayListResponses, MeetingsEventsWithActivityUpdateData, MeetingsEventsWithActivityUpdateResponses, MeetingsExportsExportRetrieveData, MeetingsExportsExportRetrieveResponses, MeetingsExportsListData, MeetingsExportsListResponses, MeetingsExportsRetrieveData, MeetingsExportsRetrieveResponses, MeetingsFormsCreateData, MeetingsFormsCreateResponses, MeetingsFormsDestroyData, MeetingsFormsDestroyResponses, MeetingsFormsDuplicateCreateData, MeetingsFormsDuplicateCreateResponses, MeetingsFormsExportSubmissionsRetrieveData, MeetingsFormsExportSubmissionsRetrieveResponses, MeetingsFormsFieldsCreateData, MeetingsFormsFieldsCreateResponses, MeetingsFormsFieldsDestroyData, MeetingsFormsFieldsDestroyResponses, MeetingsFormsFieldsListData, MeetingsFormsFieldsListResponses, MeetingsFormsFieldsPartialUpdateData, MeetingsFormsFieldsPartialUpdateResponses, MeetingsFormsFieldsRetrieveData, MeetingsFormsFieldsRetrieveResponses, MeetingsFormsFieldsUpdateData, MeetingsFormsFieldsUpdateResponses, MeetingsFormsListData, MeetingsFormsListResponses, MeetingsFormsPartialUpdateData, MeetingsFormsPartialUpdateResponses, MeetingsFormsPublicListData, MeetingsFormsPublicListResponses, MeetingsFormsPublicRetrieveData, MeetingsFormsPublicRetrieveResponses, MeetingsFormsPublishCreateData, MeetingsFormsPublishCreateResponses, MeetingsFormsRetrieveData, MeetingsFormsRetrieveResponses, MeetingsFormsSubmissionsCreateData, MeetingsFormsSubmissionsCreateResponses, MeetingsFormsSubmissionsDestroyData, MeetingsFormsSubmissionsDestroyResponses, MeetingsFormsSubmissionsListData, MeetingsFormsSubmissionsListResponses, MeetingsFormsSubmissionsPartialUpdateData, MeetingsFormsSubmissionsPartialUpdateResponses, MeetingsFormsSubmissionsRetrieveData, MeetingsFormsSubmissionsRetrieveResponses, MeetingsFormsSubmissionsUpdateData, MeetingsFormsSubmissionsUpdateResponses, MeetingsFormsUnpublishCreateData, MeetingsFormsUnpublishCreateResponses, MeetingsFormsUpdateData, MeetingsFormsUpdateResponses, MeetingsInfoCampaignCreateData, MeetingsInfoCampaignCreateResponses, MeetingsInfoCampaignListData, MeetingsInfoCampaignListResponses, MeetingsInfoCampaignPartialUpdateData, MeetingsInfoCampaignPartialUpdateResponses, MeetingsInfoCampaignUpdateData, MeetingsInfoCampaignUpdateResponses, MeetingsListData, MeetingsListResponses, MeetingsModulesToggleCreateData, MeetingsModulesToggleCreateErrors, MeetingsModulesToggleCreateResponses, MeetingsMyParticipationPartialUpdateData, MeetingsMyParticipationPartialUpdateResponses, MeetingsMyParticipationRetrieveData, MeetingsMyParticipationRetrieveResponses, MeetingsMyParticipationUpdateData, MeetingsMyParticipationUpdateResponses, MeetingsParticipantsAvatarMediaRetrieveData, MeetingsParticipantsAvatarMediaRetrieveResponses, MeetingsParticipantsAvatarMediaUpdateData, MeetingsParticipantsAvatarMediaUpdateResponses, MeetingsParticipantsCommentsCreateData, MeetingsParticipantsCommentsCreateResponses, MeetingsParticipantsCommentsDestroyData, MeetingsParticipantsCommentsDestroyResponses, MeetingsParticipantsCommentsListData, MeetingsParticipantsCommentsListResponses, MeetingsParticipantsCommentsPartialUpdateData, MeetingsParticipantsCommentsPartialUpdateResponses, MeetingsParticipantsCommentsRetrieveData, MeetingsParticipantsCommentsRetrieveResponses, MeetingsParticipantsCommentsUpdateData, MeetingsParticipantsCommentsUpdateResponses, MeetingsParticipantsListData, MeetingsParticipantsListResponses, MeetingsParticipantsOpinionListListData, MeetingsParticipantsOpinionListListResponses, MeetingsParticipantsOpinionPartialUpdateData, MeetingsParticipantsOpinionPartialUpdateResponses, MeetingsParticipantsOpinionRetrieveData, MeetingsParticipantsOpinionRetrieveResponses, MeetingsParticipantsOpinionUpdateData, MeetingsParticipantsOpinionUpdateResponses, MeetingsParticipantsPartialUpdateData, MeetingsParticipantsPartialUpdateResponses, MeetingsParticipantsResetAvatarDestroyData, MeetingsParticipantsResetAvatarDestroyResponses, MeetingsParticipantsResetSignatureDestroyData, MeetingsParticipantsResetSignatureDestroyResponses, MeetingsParticipantsRetrieveData, MeetingsParticipantsRetrieveResponses, MeetingsParticipantsSignatureMediaRetrieveData, MeetingsParticipantsSignatureMediaRetrieveResponses, MeetingsParticipantsSignatureMediaUpdateData, MeetingsParticipantsSignatureMediaUpdateResponses, MeetingsParticipantsUpdateData, MeetingsParticipantsUpdateResponses, MeetingsPublicAccessRightsRetrieveData, MeetingsPublicAccessRightsRetrieveResponses, MeetingsPublicListData, MeetingsPublicListResponses, MeetingsPublicRetrieveData, MeetingsPublicRetrieveResponses, MeetingsRequestAnonymizationPartialUpdateData, MeetingsRequestAnonymizationPartialUpdateResponses, MeetingsResetParticipantsAvatarDestroyData, MeetingsResetParticipantsAvatarDestroyResponses, MeetingsResetParticipantsSignatureDestroyData, MeetingsResetParticipantsSignatureDestroyResponses, MeetingsResourcesCreateData, MeetingsResourcesCreateResponses, MeetingsResourcesDestroyData, MeetingsResourcesDestroyResponses, MeetingsResourcesPartialUpdateData, MeetingsResourcesPartialUpdateResponses, MeetingsResourcesPublicCreateData, MeetingsResourcesPublicCreateResponses, MeetingsResourcesPublicPartialUpdateData, MeetingsResourcesPublicPartialUpdateResponses, MeetingsResourcesPublicResourceMediaRetrieveData, MeetingsResourcesPublicResourceMediaRetrieveResponses, MeetingsResourcesPublicResourceMediaUpdateData, MeetingsResourcesPublicResourceMediaUpdateResponses, MeetingsResourcesPublicRetrieveData, MeetingsResourcesPublicRetrieveResponses, MeetingsResourcesPublicTreeRetrieveData, MeetingsResourcesPublicTreeRetrieveResponses, MeetingsResourcesPublicUpdateData, MeetingsResourcesPublicUpdateResponses, MeetingsResourcesResourceMediaRetrieveData, MeetingsResourcesResourceMediaRetrieveResponses, MeetingsResourcesResourceMediaUpdateData, MeetingsResourcesResourceMediaUpdateResponses, MeetingsResourcesRetrieveData, MeetingsResourcesRetrieveResponses, MeetingsResourcesTreeRetrieveData, MeetingsResourcesTreeRetrieveResponses, MeetingsResourcesUpdateData, MeetingsResourcesUpdateResponses, MeetingsResourcesUrlTemplatePlaceholdersRetrieveData, MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses, MeetingsRetrieveData, MeetingsRetrieveResponses, MeetingsRetrieveTagadaCandidateRetrieveData, MeetingsRetrieveTagadaCandidateRetrieveResponses, MeetingsRoomsCreateData, MeetingsRoomsCreateResponses, MeetingsRoomsDestroyData, MeetingsRoomsDestroyResponses, MeetingsRoomsListData, MeetingsRoomsListResponses, MeetingsRoomsPartialUpdateData, MeetingsRoomsPartialUpdateResponses, MeetingsRoomsRetrieveData, MeetingsRoomsRetrieveResponses, MeetingsRoomsUpdateData, MeetingsRoomsUpdateResponses, MeetingsSyncAvisTagadaCreateData, MeetingsSyncAvisTagadaCreateResponses, MeetingsSyncFromIntranetCreateData, MeetingsSyncFromIntranetCreateResponses, MeetingsSyncParticipantsTagadaCreateData, MeetingsSyncParticipantsTagadaCreateResponses, MeetingsTableExportsParticipantEnrollementsRetrieveData, MeetingsTableExportsParticipantEnrollementsRetrieveResponses, MeetingsTableExportsParticipantListDirectionRetrieveData, MeetingsTableExportsParticipantListDirectionRetrieveResponses, MeetingsTableExportsParticipantListRetrieveData, MeetingsTableExportsParticipantListRetrieveResponses, MeetingsTableExportsProcesVerbalRetrieveData, MeetingsTableExportsProcesVerbalRetrieveResponses, MeetingsTableExportsTeamsdailytasksbytaskRetrieveData, MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses, MeetingsTableExportsTeamsdailytasksbyteamRetrieveData, MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses, MeetingsTeamDailyTasksCreateData, MeetingsTeamDailyTasksCreateResponses, MeetingsTeamDailyTasksDestroyData, MeetingsTeamDailyTasksDestroyResponses, MeetingsTeamDailyTasksListData, MeetingsTeamDailyTasksListResponses, MeetingsTeamDailyTasksPartialUpdateData, MeetingsTeamDailyTasksPartialUpdateResponses, MeetingsTeamDailyTasksRetrieveData, MeetingsTeamDailyTasksRetrieveResponses, MeetingsTeamDailyTasksUpdateData, MeetingsTeamDailyTasksUpdateResponses, MeetingsTeamsCategoriesCreateData, MeetingsTeamsCategoriesCreateResponses, MeetingsTeamsCategoriesDestroyData, MeetingsTeamsCategoriesDestroyResponses, MeetingsTeamsCategoriesListData, MeetingsTeamsCategoriesListResponses, MeetingsTeamsCategoriesPartialUpdateData, MeetingsTeamsCategoriesPartialUpdateResponses, MeetingsTeamsCategoriesRetrieveData, MeetingsTeamsCategoriesRetrieveResponses, MeetingsTeamsCategoriesUpdateData, MeetingsTeamsCategoriesUpdateResponses, MeetingsTeamsCreateData, MeetingsTeamsCreateResponses, MeetingsTeamsDestroyData, MeetingsTeamsDestroyResponses, MeetingsTeamsListData, MeetingsTeamsListResponses, MeetingsTeamsPartialUpdateData, MeetingsTeamsPartialUpdateResponses, MeetingsTeamsParticipantsRetrieveData, MeetingsTeamsParticipantsRetrieveResponses, MeetingsTeamsParticipantsUpdateData, MeetingsTeamsParticipantsUpdateResponses, MeetingsTeamsRetrieveData, MeetingsTeamsRetrieveResponses, MeetingsTeamsUpdateData, MeetingsTeamsUpdateResponses, MeetingsTracksCreateData, MeetingsTracksCreateResponses, MeetingsTracksDestroyData, MeetingsTracksDestroyResponses, MeetingsTracksListData, MeetingsTracksListResponses, MeetingsTracksPartialUpdateData, MeetingsTracksPartialUpdateResponses, MeetingsTracksRetrieveData, MeetingsTracksRetrieveResponses, MeetingsTracksUpdateData, MeetingsTracksUpdateResponses, MeetingTypesListData, MeetingTypesListResponses, MeetingTypesRetrieveData, MeetingTypesRetrieveResponses, ParticipantsExportsProcesVerbalRetrieveData, ParticipantsExportsProcesVerbalRetrieveResponses, PlacesListData, PlacesListResponses, PlacesRetrieveData, PlacesRetrieveResponses, SchemaRetrieveData, SchemaRetrieveResponses, StructureExportsExportRetrieveData, StructureExportsExportRetrieveResponses, StructureExportsListByGroupeListData, StructureExportsListByGroupeListResponses, StructureExportsListByTerritoireListData, StructureExportsListByTerritoireListResponses, StructureExportsListData, StructureExportsListResponses, StructuresCentresRessourceListData, StructuresCentresRessourceListResponses, StructuresOrganisatriceListData, StructuresOrganisatriceListResponses, UsersAccessRightsRetrieveData, UsersAccessRightsRetrieveResponses, UsersAvatarMediaRetrieveData, UsersAvatarMediaRetrieveResponses, UsersAvatarMediaUpdateData, UsersAvatarMediaUpdateResponses, UsersDeontologieEnableCreateData, UsersDeontologieEnableCreateResponses, UsersDiplomasCreateData, UsersDiplomasCreateResponses, UsersDiplomasDestroyData, UsersDiplomasDestroyResponses, UsersDiplomasDiplomaMediaRetrieveData, UsersDiplomasDiplomaMediaRetrieveResponses, UsersDiplomasDiplomaMediaUpdateData, UsersDiplomasDiplomaMediaUpdateResponses, UsersDiplomasListData, UsersDiplomasListResponses, UsersDiplomasPartialUpdateData, UsersDiplomasPartialUpdateResponses, UsersDiplomasRetrieveData, UsersDiplomasRetrieveResponses, UsersDiplomasUpdateData, UsersDiplomasUpdateResponses, UsersMeRetrieveData, UsersMeRetrieveResponses, UsersResetAvatarDestroyData, UsersResetAvatarDestroyResponses, UsersResetSignatureDestroyData, UsersResetSignatureDestroyResponses, UsersRetrieveData, UsersRetrieveResponses, UsersSignatureMediaRetrieveData, UsersSignatureMediaRetrieveResponses, UsersSignatureMediaUpdateData, UsersSignatureMediaUpdateResponses, WebhooksCronMeetingCreateData, WebhooksCronMeetingCreateResponses, WebhooksCronMeetingParticipantCreateData, WebhooksCronMeetingParticipantCreateResponses, WebhooksCronMeetingTypeCreateData, WebhooksCronMeetingTypeCreateResponses, WebhooksCronPlaceCreateData, WebhooksCronPlaceCreateResponses, WebhooksCronStructureCreateData, WebhooksCronStructureCreateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Takes a set of user credentials and returns an access and refresh JSON web
 * token pair to prove the authentication of those credentials.
 */
export const authJwtCreateCreate = <ThrowOnError extends boolean = false>(options: Options<AuthJwtCreateCreateData, ThrowOnError>): RequestResult<AuthJwtCreateCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthJwtCreateCreateResponses, unknown, ThrowOnError>({
    url: '/api/auth/jwt/create/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
 */
export const authJwtRefreshCreate = <ThrowOnError extends boolean = false>(options: Options<AuthJwtRefreshCreateData, ThrowOnError>): RequestResult<AuthJwtRefreshCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthJwtRefreshCreateResponses, unknown, ThrowOnError>({
    url: '/api/auth/jwt/refresh/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes a token and indicates if it is valid.  This view provides no
 * information about a token's fitness for a particular use.
 */
export const authJwtVerifyCreate = <ThrowOnError extends boolean = false>(options: Options<AuthJwtVerifyCreateData, ThrowOnError>): RequestResult<AuthJwtVerifyCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthJwtVerifyCreateResponses, unknown, ThrowOnError>({
    url: '/api/auth/jwt/verify/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Demande une url d'authentication pour keycloak
 */
export const authORetrieve = <ThrowOnError extends boolean = false>(options: Options<AuthORetrieveData, ThrowOnError>): RequestResult<AuthORetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<AuthORetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/o/{provider}/',
    ...options
});

/**
 * Confirmer l'authentification par keycloak
 */
export const authOCreate = <ThrowOnError extends boolean = false>(options: Options<AuthOCreateData, ThrowOnError>): RequestResult<AuthOCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthOCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/o/{provider}/',
    ...options
});

export const authUsersList = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersListData, ThrowOnError>): RequestResult<AuthUsersListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthUsersListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/',
    ...options
});

export const authUsersCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersCreateData, ThrowOnError>): RequestResult<AuthUsersCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authUsersDestroy = <ThrowOnError extends boolean = false>(options: Options<AuthUsersDestroyData, ThrowOnError>): RequestResult<AuthUsersDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<AuthUsersDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/{id}/',
    ...options
});

export const authUsersRetrieve = <ThrowOnError extends boolean = false>(options: Options<AuthUsersRetrieveData, ThrowOnError>): RequestResult<AuthUsersRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<AuthUsersRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/{id}/',
    ...options
});

export const authUsersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersPartialUpdateData, ThrowOnError>): RequestResult<AuthUsersPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AuthUsersPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/{id}/',
    ...options
});

export const authUsersUpdate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersUpdateData, ThrowOnError>): RequestResult<AuthUsersUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<AuthUsersUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/{id}/',
    ...options
});

export const authUsersActivationCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersActivationCreateData, ThrowOnError>): RequestResult<AuthUsersActivationCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersActivationCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/activation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authUsersMeDestroy = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersMeDestroyData, ThrowOnError>): RequestResult<AuthUsersMeDestroyResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<AuthUsersMeDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/me/',
    ...options
});

export const authUsersMeRetrieve = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersMeRetrieveData, ThrowOnError>): RequestResult<AuthUsersMeRetrieveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthUsersMeRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/me/',
    ...options
});

export const authUsersMePartialUpdate = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersMePartialUpdateData, ThrowOnError>): RequestResult<AuthUsersMePartialUpdateResponses, unknown, ThrowOnError> => (options?.client ?? client).patch<AuthUsersMePartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/me/',
    ...options
});

export const authUsersMeUpdate = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersMeUpdateData, ThrowOnError>): RequestResult<AuthUsersMeUpdateResponses, unknown, ThrowOnError> => (options?.client ?? client).put<AuthUsersMeUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/me/',
    ...options
});

export const authUsersResendActivationCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersResendActivationCreateData, ThrowOnError>): RequestResult<AuthUsersResendActivationCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersResendActivationCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/resend_activation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password
 */
export const authUsersResetPasswordCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersResetPasswordCreateData, ThrowOnError>): RequestResult<AuthUsersResetPasswordCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersResetPasswordCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/reset_password/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password confirm
 */
export const authUsersResetPasswordConfirmCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersResetPasswordConfirmCreateData, ThrowOnError>): RequestResult<AuthUsersResetPasswordConfirmCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersResetPasswordConfirmCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/reset_password_confirm/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authUsersResetUsernameCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersResetUsernameCreateData, ThrowOnError>): RequestResult<AuthUsersResetUsernameCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersResetUsernameCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/reset_username/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authUsersResetUsernameConfirmCreate = <ThrowOnError extends boolean = false>(options?: Options<AuthUsersResetUsernameConfirmCreateData, ThrowOnError>): RequestResult<AuthUsersResetUsernameConfirmCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthUsersResetUsernameConfirmCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/reset_username_confirm/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const authUsersSetPasswordCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersSetPasswordCreateData, ThrowOnError>): RequestResult<AuthUsersSetPasswordCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersSetPasswordCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/set_password/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authUsersSetUsernameCreate = <ThrowOnError extends boolean = false>(options: Options<AuthUsersSetUsernameCreateData, ThrowOnError>): RequestResult<AuthUsersSetUsernameCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthUsersSetUsernameCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/auth/users/set_username/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsList = <ThrowOnError extends boolean = false>(options?: Options<ExportsListData, ThrowOnError>): RequestResult<ExportsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ExportsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/',
    ...options
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsCreate = <ThrowOnError extends boolean = false>(options: Options<ExportsCreateData, ThrowOnError>): RequestResult<ExportsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExportsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const exportsParticipantsExportRetrieve = <ThrowOnError extends boolean = false>(options: Options<ExportsParticipantsExportRetrieveData, ThrowOnError>): RequestResult<ExportsParticipantsExportRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExportsParticipantsExportRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: exportsParticipantsExportRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{doctemplate_id}/participants/{participant_id}/export/',
    ...options
});

/**
 * Génère un export compilé pour un gestionnaire
 */
export const exportsParticipantsExportMultipleRetrieve = <ThrowOnError extends boolean = false>(options: Options<ExportsParticipantsExportMultipleRetrieveData, ThrowOnError>): RequestResult<ExportsParticipantsExportMultipleRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExportsParticipantsExportMultipleRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: exportsParticipantsExportMultipleRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{doctemplate_id}/participants/export-multiple/',
    ...options
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsDestroy = <ThrowOnError extends boolean = false>(options: Options<ExportsDestroyData, ThrowOnError>): RequestResult<ExportsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ExportsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{id}/',
    ...options
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ExportsRetrieveData, ThrowOnError>): RequestResult<ExportsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExportsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{id}/',
    ...options
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ExportsPartialUpdateData, ThrowOnError>): RequestResult<ExportsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ExportsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This viewset provides actions to manage DocTemplates
 */
export const exportsUpdate = <ThrowOnError extends boolean = false>(options: Options<ExportsUpdateData, ThrowOnError>): RequestResult<ExportsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<ExportsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/exports/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liste tous les stages quand je suis gestionnaire
 */
export const gestionnaireMeetingsList = <ThrowOnError extends boolean = false>(options?: Options<GestionnaireMeetingsListData, ThrowOnError>): RequestResult<GestionnaireMeetingsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GestionnaireMeetingsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { meeting_type__id__in: { array: { explode: false } } } },
    responseTransformer: gestionnaireMeetingsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/',
    ...options
});

/**
 * Lit le stage
 */
export const gestionnaireMeetingsRetrieve = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsRetrieveData, ThrowOnError>): RequestResult<GestionnaireMeetingsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<GestionnaireMeetingsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const gestionnaireMeetingsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsPartialUpdateData, ThrowOnError>): RequestResult<GestionnaireMeetingsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<GestionnaireMeetingsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const gestionnaireMeetingsUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsUpdateData, ThrowOnError>): RequestResult<GestionnaireMeetingsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<GestionnaireMeetingsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Information modifiable du participant courant
 */
export const gestionnaireMeetingsMyParticipationRetrieve = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsMyParticipationRetrieveData, ThrowOnError>): RequestResult<GestionnaireMeetingsMyParticipationRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<GestionnaireMeetingsMyParticipationRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsMyParticipationRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/my-participation/',
    ...options
});

/**
 * Information modifiable du participant courant
 */
export const gestionnaireMeetingsMyParticipationPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsMyParticipationPartialUpdateData, ThrowOnError>): RequestResult<GestionnaireMeetingsMyParticipationPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<GestionnaireMeetingsMyParticipationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/my-participation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Information modifiable du participant courant
 */
export const gestionnaireMeetingsMyParticipationUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsMyParticipationUpdateData, ThrowOnError>): RequestResult<GestionnaireMeetingsMyParticipationUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<GestionnaireMeetingsMyParticipationUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/my-participation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Place le stage fermé en statut prêt à être à anonymisé (ou annule la demande d'anonymisation)
 */
export const gestionnaireMeetingsRequestAnonymizationPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsRequestAnonymizationPartialUpdateData, ThrowOnError>): RequestResult<GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/request-anonymization/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const gestionnaireMeetingsResetParticipantsAvatarDestroy = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsResetParticipantsAvatarDestroyData, ThrowOnError>): RequestResult<GestionnaireMeetingsResetParticipantsAvatarDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<GestionnaireMeetingsResetParticipantsAvatarDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/reset-participants-avatar/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const gestionnaireMeetingsResetParticipantsSignatureDestroy = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsResetParticipantsSignatureDestroyData, ThrowOnError>): RequestResult<GestionnaireMeetingsResetParticipantsSignatureDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<GestionnaireMeetingsResetParticipantsSignatureDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/reset-participants-signature/',
    ...options
});

/**
 * Récupère des informations sur un candidat depuis Tagada à partir de son numéro BAFA/BAFD
 */
export const gestionnaireMeetingsRetrieveTagadaCandidateRetrieve = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsRetrieveTagadaCandidateRetrieveData, ThrowOnError>): RequestResult<GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/retrieve-tagada-candidate/',
    ...options
});

/**
 * Synchronise les avis de stages des participants de la formation avec Tagada : l'intranet ddcs
 */
export const gestionnaireMeetingsSyncAvisTagadaCreate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsSyncAvisTagadaCreateData, ThrowOnError>): RequestResult<GestionnaireMeetingsSyncAvisTagadaCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<GestionnaireMeetingsSyncAvisTagadaCreateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsSyncAvisTagadaCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/sync-avis-tagada/',
    ...options
});

/**
 * Synchronise une formation.
 * Synchronise aussi les participants à la formation
 */
export const gestionnaireMeetingsSyncFromIntranetCreate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsSyncFromIntranetCreateData, ThrowOnError>): RequestResult<GestionnaireMeetingsSyncFromIntranetCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<GestionnaireMeetingsSyncFromIntranetCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/sync-from-intranet/',
    ...options
});

/**
 * Synchronise  les participants de la formation avec Tagada : l'intranet ddcs
 */
export const gestionnaireMeetingsSyncParticipantsTagadaCreate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireMeetingsSyncParticipantsTagadaCreateData, ThrowOnError>): RequestResult<GestionnaireMeetingsSyncParticipantsTagadaCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<GestionnaireMeetingsSyncParticipantsTagadaCreateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireMeetingsSyncParticipantsTagadaCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/{id}/sync-participants-tagada/',
    ...options
});

/**
 * Liste les stages dont mes structures sont organisatrices
 */
export const gestionnaireMeetingsMyScopeListList = <ThrowOnError extends boolean = false>(options?: Options<GestionnaireMeetingsMyScopeListListData, ThrowOnError>): RequestResult<GestionnaireMeetingsMyScopeListListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GestionnaireMeetingsMyScopeListListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { meeting_type__id__in: { array: { explode: false } } } },
    responseTransformer: gestionnaireMeetingsMyScopeListListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-meetings/my-scope-list/',
    ...options
});

/**
 * Liste tous les participants aux actions de formation où je suis gestionnaire
 */
export const gestionnaireParticipantsList = <ThrowOnError extends boolean = false>(options: Options<GestionnaireParticipantsListData, ThrowOnError>): RequestResult<GestionnaireParticipantsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<GestionnaireParticipantsListResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireParticipantsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-participants/',
    ...options
});

/**
 * Récupère un participant par uuid
 */
export const gestionnaireParticipantsRetrieve = <ThrowOnError extends boolean = false>(options: Options<GestionnaireParticipantsRetrieveData, ThrowOnError>): RequestResult<GestionnaireParticipantsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<GestionnaireParticipantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireParticipantsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-participants/{id}/',
    ...options
});

export const gestionnaireParticipantsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireParticipantsPartialUpdateData, ThrowOnError>): RequestResult<GestionnaireParticipantsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<GestionnaireParticipantsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireParticipantsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-participants/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const gestionnaireParticipantsUpdate = <ThrowOnError extends boolean = false>(options: Options<GestionnaireParticipantsUpdateData, ThrowOnError>): RequestResult<GestionnaireParticipantsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<GestionnaireParticipantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: gestionnaireParticipantsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/gestionnaire-participants/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recuperer les metadonnées du media auquel fait reference l'url
 */
export const mediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<MediaRetrieveData, ThrowOnError>): RequestResult<MediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: mediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/media/{url_hash}/',
    ...options
});

/**
 * Recupérer le fichier media
 */
export const mediaFileRetrieve = <ThrowOnError extends boolean = false>(options: Options<MediaFileRetrieveData, ThrowOnError>): RequestResult<MediaFileRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MediaFileRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/media/{url_hash}/file/',
    ...options
});

/**
 * Téléverser le media
 */
export const mediaFileUpdate = <ThrowOnError extends boolean = false>(options: Options<MediaFileUpdateData, ThrowOnError>): RequestResult<MediaFileUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MediaFileUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/media/{url_hash}/file/',
    ...options
});

/**
 * Un Module est une fonctionnalité de digiform pour une formation par exemple
 * le Planning ou les Liens Utiles.
 * Les modules peuvent être activés ou desactivés par formation.
 */
export const meetingModulesList = <ThrowOnError extends boolean = false>(options?: Options<MeetingModulesListData, ThrowOnError>): RequestResult<MeetingModulesListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeetingModulesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-modules/',
    ...options
});

/**
 * Un Module est une fonctionnalité de digiform pour une formation par exemple
 * le Planning ou les Liens Utiles.
 * Les modules peuvent être activés ou desactivés par formation.
 */
export const meetingModulesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingModulesRetrieveData, ThrowOnError>): RequestResult<MeetingModulesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingModulesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-modules/{id}/',
    ...options
});

/**
 * Un "MeetingRole" correspond à un rôle dans une action de formation (Directeur, Participant, ...)
 */
export const meetingRolesList = <ThrowOnError extends boolean = false>(options?: Options<MeetingRolesListData, ThrowOnError>): RequestResult<MeetingRolesListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeetingRolesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-roles/',
    ...options
});

/**
 * Un "MeetingRole" correspond à un rôle dans une action de formation (Directeur, Participant, ...)
 */
export const meetingRolesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingRolesRetrieveData, ThrowOnError>): RequestResult<MeetingRolesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingRolesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-roles/{id}/',
    ...options
});

/**
 * Un "MeetingType" correspond à un type d'action de formation ou d'événement : TECH, APPRO, ...
 */
export const meetingTypesList = <ThrowOnError extends boolean = false>(options?: Options<MeetingTypesListData, ThrowOnError>): RequestResult<MeetingTypesListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeetingTypesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-types/',
    ...options
});

/**
 * Un "MeetingType" correspond à un type d'action de formation ou d'événement : TECH, APPRO, ...
 */
export const meetingTypesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingTypesRetrieveData, ThrowOnError>): RequestResult<MeetingTypesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingTypesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meeting-types/{id}/',
    ...options
});

/**
 * Liste seulement les stages où je suis participant
 */
export const meetingsList = <ThrowOnError extends boolean = false>(options?: Options<MeetingsListData, ThrowOnError>): RequestResult<MeetingsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeetingsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { meeting_type__id__in: { array: { explode: false } } } },
    responseTransformer: meetingsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/',
    ...options
});

/**
 * Liste seulement les stages où je suis participant
 */
export const meetingsPublicList = <ThrowOnError extends boolean = false>(options?: Options<MeetingsPublicListData, ThrowOnError>): RequestResult<MeetingsPublicListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeetingsPublicListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { meeting_type__id__in: { array: { explode: false } } } },
    responseTransformer: meetingsPublicListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings-public/',
    ...options
});

/**
 * Lit le stage
 */
export const meetingsPublicRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsPublicRetrieveData, ThrowOnError>): RequestResult<MeetingsPublicRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsPublicRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsPublicRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings-public/{id}/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const meetingsPublicAccessRightsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsPublicAccessRightsRetrieveData, ThrowOnError>): RequestResult<MeetingsPublicAccessRightsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsPublicAccessRightsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings-public/{id}/access-rights/',
    ...options
});

/**
 * Lit le stage
 */
export const meetingsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsRetrieveData, ThrowOnError>): RequestResult<MeetingsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/',
    ...options
});

/**
 * Information modifiable du participant courant
 */
export const meetingsMyParticipationRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsMyParticipationRetrieveData, ThrowOnError>): RequestResult<MeetingsMyParticipationRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsMyParticipationRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsMyParticipationRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/my-participation/',
    ...options
});

/**
 * Information modifiable du participant courant
 */
export const meetingsMyParticipationPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsMyParticipationPartialUpdateData, ThrowOnError>): RequestResult<MeetingsMyParticipationPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsMyParticipationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/my-participation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Information modifiable du participant courant
 */
export const meetingsMyParticipationUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsMyParticipationUpdateData, ThrowOnError>): RequestResult<MeetingsMyParticipationUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsMyParticipationUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/my-participation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Place le stage fermé en statut prêt à être à anonymisé (ou annule la demande d'anonymisation)
 */
export const meetingsRequestAnonymizationPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsRequestAnonymizationPartialUpdateData, ThrowOnError>): RequestResult<MeetingsRequestAnonymizationPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsRequestAnonymizationPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/request-anonymization/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const meetingsResetParticipantsAvatarDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsResetParticipantsAvatarDestroyData, ThrowOnError>): RequestResult<MeetingsResetParticipantsAvatarDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsResetParticipantsAvatarDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/reset-participants-avatar/',
    ...options
});

/**
 * Un "Meeting" correspond à une action de formation, un événement d'un ou plusieurs jours
 */
export const meetingsResetParticipantsSignatureDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsResetParticipantsSignatureDestroyData, ThrowOnError>): RequestResult<MeetingsResetParticipantsSignatureDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsResetParticipantsSignatureDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/reset-participants-signature/',
    ...options
});

/**
 * Récupère des informations sur un candidat depuis Tagada à partir de son numéro BAFA/BAFD
 */
export const meetingsRetrieveTagadaCandidateRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsRetrieveTagadaCandidateRetrieveData, ThrowOnError>): RequestResult<MeetingsRetrieveTagadaCandidateRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsRetrieveTagadaCandidateRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/retrieve-tagada-candidate/',
    ...options
});

/**
 * Synchronise les avis de stages des participants de la formation avec Tagada : l'intranet ddcs
 */
export const meetingsSyncAvisTagadaCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsSyncAvisTagadaCreateData, ThrowOnError>): RequestResult<MeetingsSyncAvisTagadaCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsSyncAvisTagadaCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsSyncAvisTagadaCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/sync-avis-tagada/',
    ...options
});

/**
 * Synchronise une formation.
 * Synchronise aussi les participants à la formation
 */
export const meetingsSyncFromIntranetCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsSyncFromIntranetCreateData, ThrowOnError>): RequestResult<MeetingsSyncFromIntranetCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsSyncFromIntranetCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/sync-from-intranet/',
    ...options
});

/**
 * Synchronise  les participants de la formation avec Tagada : l'intranet ddcs
 */
export const meetingsSyncParticipantsTagadaCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsSyncParticipantsTagadaCreateData, ThrowOnError>): RequestResult<MeetingsSyncParticipantsTagadaCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsSyncParticipantsTagadaCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsSyncParticipantsTagadaCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{id}/sync-participants-tagada/',
    ...options
});

/**
 * Lister les activités d'évenement
 */
export const meetingsActivitiesList = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesListData, ThrowOnError>): RequestResult<MeetingsActivitiesListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivitiesListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_relation_type__in: { array: { explode: false } } } },
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/',
    ...options
});

/**
 * Créer une activité d'évenement
 */
export const meetingsActivitiesCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesCreateData, ThrowOnError>): RequestResult<MeetingsActivitiesCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsActivitiesCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Détruire une activité
 */
export const meetingsActivitiesDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesDestroyData, ThrowOnError>): RequestResult<MeetingsActivitiesDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsActivitiesDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/{id}/',
    ...options
});

/**
 * Récupérer les détails d'une activité
 */
export const meetingsActivitiesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesRetrieveData, ThrowOnError>): RequestResult<MeetingsActivitiesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivitiesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/{id}/',
    ...options
});

/**
 * Mettre à jour partiellement une activité
 */
export const meetingsActivitiesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesPartialUpdateData, ThrowOnError>): RequestResult<MeetingsActivitiesPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsActivitiesPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mettre à jour une activité
 */
export const meetingsActivitiesUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivitiesUpdateData, ThrowOnError>): RequestResult<MeetingsActivitiesUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsActivitiesUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activities/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liste les catégories personnalisées ainsi que les catégories génériques
 */
export const meetingsActivityCategoriesList = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesListData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivityCategoriesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/',
    ...options
});

/**
 * Créer une catégorie d'événement
 */
export const meetingsActivityCategoriesCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesCreateData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsActivityCategoriesCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprimer une catégorie d'événement
 */
export const meetingsActivityCategoriesDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesDestroyData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsActivityCategoriesDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/',
    ...options
});

/**
 * Récupère les catégories personnalisées ainsi que les catégories génériques
 */
export const meetingsActivityCategoriesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesRetrieveData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivityCategoriesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/',
    ...options
});

/**
 * Mettre à jour partiellement une catégorie d'événement
 */
export const meetingsActivityCategoriesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesPartialUpdateData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsActivityCategoriesPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mettre à jour une catégorie d'événement
 */
export const meetingsActivityCategoriesUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityCategoriesUpdateData, ThrowOnError>): RequestResult<MeetingsActivityCategoriesUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsActivityCategoriesUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liste des thématiques
 */
export const meetingsActivityTopicsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsListData, ThrowOnError>): RequestResult<MeetingsActivityTopicsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivityTopicsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/',
    ...options
});

/**
 * Créer un thème d'evenement
 */
export const meetingsActivityTopicsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsCreateData, ThrowOnError>): RequestResult<MeetingsActivityTopicsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsActivityTopicsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprimer une thématique d'événement
 */
export const meetingsActivityTopicsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsDestroyData, ThrowOnError>): RequestResult<MeetingsActivityTopicsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsActivityTopicsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/',
    ...options
});

/**
 * Récupèrer une thématique d'evenement
 */
export const meetingsActivityTopicsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsRetrieveData, ThrowOnError>): RequestResult<MeetingsActivityTopicsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsActivityTopicsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/',
    ...options
});

/**
 * Mettre à jour partiellement une thématique d'événement
 */
export const meetingsActivityTopicsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsActivityTopicsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsActivityTopicsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mettre à jour une thématique d'événement
 */
export const meetingsActivityTopicsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsActivityTopicsUpdateData, ThrowOnError>): RequestResult<MeetingsActivityTopicsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsActivityTopicsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all tags available for the comments
 */
export const meetingsCommentTagsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsListData, ThrowOnError>): RequestResult<MeetingsCommentTagsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsCommentTagsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/',
    ...options
});

/**
 * Create a new tag for comments
 */
export const meetingsCommentTagsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsCreateData, ThrowOnError>): RequestResult<MeetingsCommentTagsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsCommentTagsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a tag for comments
 */
export const meetingsCommentTagsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsDestroyData, ThrowOnError>): RequestResult<MeetingsCommentTagsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsCommentTagsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/',
    ...options
});

/**
 * Get a single tag for comments
 */
export const meetingsCommentTagsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsRetrieveData, ThrowOnError>): RequestResult<MeetingsCommentTagsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsCommentTagsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/',
    ...options
});

/**
 * Partially update a tag
 */
export const meetingsCommentTagsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsCommentTagsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsCommentTagsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a tag
 */
export const meetingsCommentTagsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsCommentTagsUpdateData, ThrowOnError>): RequestResult<MeetingsCommentTagsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsCommentTagsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the DailyTaskTeams for the meeting
 */
export const meetingsDailyTaskTeamsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsListData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTaskTeamsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/',
    ...options
});

/**
 * Create a new DailyTaskTeams for the meeting
 */
export const meetingsDailyTaskTeamsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsCreateData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsDailyTaskTeamsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a DailyTaskTeams
 */
export const meetingsDailyTaskTeamsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsDestroyData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsDailyTaskTeamsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/',
    ...options
});

/**
 * Retrieve a single DailyTaskTeams from the meeting
 */
export const meetingsDailyTaskTeamsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsRetrieveData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTaskTeamsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/',
    ...options
});

/**
 * Partially update a single DailyTaskTeams
 */
export const meetingsDailyTaskTeamsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsDailyTaskTeamsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a single DailyTaskTeams
 */
export const meetingsDailyTaskTeamsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsUpdateData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsDailyTaskTeamsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of MeetingParticipants associated to a DailyTaskTeam
 */
export const meetingsDailyTaskTeamsParticipantsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsParticipantsRetrieveData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsParticipantsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTaskTeamsParticipantsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/participants/',
    ...options
});

/**
 * Update the list of MeetingParticipants associated to a DailyTaskTeam
 * Only MeetingParticipant of this list will be assigned
 */
export const meetingsDailyTaskTeamsParticipantsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsParticipantsUpdateData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsParticipantsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsDailyTaskTeamsParticipantsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/participants/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retourne la liste des Services assignes à une Equipe pour une Formation donnée.
 */
export const meetingsDailyTaskTeamsTeamDailyTasksList = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsTeamDailyTasksListData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsTeamDailyTasksListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTaskTeamsTeamDailyTasksListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsDailyTaskTeamsTeamDailyTasksListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/',
    ...options
});

/**
 * Récupère les informations d'une instance de Service assigné à une Equipe via son ID pour une Formation donnée.
 */
export const meetingsDailyTaskTeamsTeamDailyTasksRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTaskTeamsTeamDailyTasksRetrieveData, ThrowOnError>): RequestResult<MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsDailyTaskTeamsTeamDailyTasksRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/{id}/',
    ...options
});

/**
 * Retourne la liste des Services pour une Formation
 */
export const meetingsDailyTasksList = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksListData, ThrowOnError>): RequestResult<MeetingsDailyTasksListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTasksListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/',
    ...options
});

/**
 * Crée une tache de Service
 */
export const meetingsDailyTasksCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksCreateData, ThrowOnError>): RequestResult<MeetingsDailyTasksCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsDailyTasksCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprime une instance de Service via son ID
 */
export const meetingsDailyTasksDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksDestroyData, ThrowOnError>): RequestResult<MeetingsDailyTasksDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsDailyTasksDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/',
    ...options
});

/**
 * Récupère les informations d'une instance de Service pour une Formation via son ID.
 */
export const meetingsDailyTasksRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksRetrieveData, ThrowOnError>): RequestResult<MeetingsDailyTasksRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTasksRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/',
    ...options
});

/**
 * Patch une instance de Service via son ID
 */
export const meetingsDailyTasksPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksPartialUpdateData, ThrowOnError>): RequestResult<MeetingsDailyTasksPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsDailyTasksPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modifie une instance de Service pour une Formation via son ID
 */
export const meetingsDailyTasksUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksUpdateData, ThrowOnError>): RequestResult<MeetingsDailyTasksUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsDailyTasksUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liste des taches quotidiennes du jour pour le participant
 */
export const meetingsDailyTasksMyDailyTasksList = <ThrowOnError extends boolean = false>(options: Options<MeetingsDailyTasksMyDailyTasksListData, ThrowOnError>): RequestResult<MeetingsDailyTasksMyDailyTasksListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsDailyTasksMyDailyTasksListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/daily-tasks/my-daily-tasks/',
    ...options
});

/**
 * Lister tous les événements
 */
export const meetingsEventsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsListData, ThrowOnError>): RequestResult<MeetingsEventsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/',
    ...options
});

/**
 * Créer un événement
 */
export const meetingsEventsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsCreateData, ThrowOnError>): RequestResult<MeetingsEventsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lister tous les événements
 */
export const meetingsEventsWithActivityList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/',
    ...options
});

/**
 * Créer un événement
 */
export const meetingsEventsWithActivityCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Détruire un événement
 */
export const meetingsEventsWithActivityDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityDestroyData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsWithActivityDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/',
    ...options
});

/**
 * Récupérer les détails d'un événement
 */
export const meetingsEventsWithActivityRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/',
    ...options
});

/**
 * Mettre à jour un événement partiellement
 */
export const meetingsEventsWithActivityPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityPartialUpdateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsEventsWithActivityPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mettre à jour un événement
 */
export const meetingsEventsWithActivityUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityUpdateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsEventsWithActivityUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Un "Event" correspond à un créneau temporel et un lien
 * pour un atelier d'une action de formation
 */
export const meetingsEventsWithActivityChildrenRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityChildrenRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityChildrenRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityChildrenRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityChildrenRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/children/',
    ...options
});

/**
 * Créer un enfant d'un événement modulaire
 */
export const meetingsEventsWithActivityChildrenCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityChildrenCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityChildrenCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityChildrenCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityChildrenCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/children/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Applique l'événement sur les jours indiqués
 */
export const meetingsEventsWithActivityCopyToDaysCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityCopyToDaysCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityCopyToDaysCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityCopyToDaysCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityCopyToDaysCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/copy-to-days/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Désinscrire un participant à un événement
 */
export const meetingsEventsWithActivityEnrollmentDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityEnrollmentDestroyData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityEnrollmentDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsWithActivityEnrollmentDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/',
    ...options
});

/**
 * Récupérer l'inscription d'un participant a  un  evenement d'un meeting
 */
export const meetingsEventsWithActivityEnrollmentList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityEnrollmentListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityEnrollmentListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityEnrollmentListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityEnrollmentListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/',
    ...options
});

/**
 * Inscrire un participant à un événement
 */
export const meetingsEventsWithActivityEnrollmentCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityEnrollmentCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityEnrollmentCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityEnrollmentCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityEnrollmentCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Desinscrire le participant courant à un événement
 */
export const meetingsEventsWithActivityMyEnrollmentDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityMyEnrollmentDestroyData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityMyEnrollmentDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsWithActivityMyEnrollmentDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/',
    ...options
});

/**
 * Récupérer l'inscription du participant courant à un événement
 */
export const meetingsEventsWithActivityMyEnrollmentRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityMyEnrollmentRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityMyEnrollmentRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityMyEnrollmentRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityMyEnrollmentRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/',
    ...options
});

/**
 * Inscrire le participant courant à un événement
 */
export const meetingsEventsWithActivityMyEnrollmentCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityMyEnrollmentCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityMyEnrollmentCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityMyEnrollmentCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityMyEnrollmentCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Applique la journée type sur les jours indiqués
 */
export const meetingsEventsWithActivityApplyTypicalDayCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityApplyTypicalDayCreateData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityApplyTypicalDayCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsWithActivityApplyTypicalDayCreateResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityApplyTypicalDayCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/apply-typical-day/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupérer l'inscription d'un participant(s) aux evenements d'un meeting
 */
export const meetingsEventsWithActivityEnrollmentsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityEnrollmentsListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityEnrollmentsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityEnrollmentsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityEnrollmentsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/enrollments/',
    ...options
});

/**
 * Liste les événements futurs dont une équipe du participant est responsable
 */
export const meetingsEventsWithActivityInChargeList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityInChargeListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityInChargeListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityInChargeListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityInChargeListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/in-charge/',
    ...options
});

/**
 * Liste les événements du jour pour le participant
 */
export const meetingsEventsWithActivityMyDailyEventsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityMyDailyEventsListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityMyDailyEventsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityMyDailyEventsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityMyDailyEventsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/my-daily-events/',
    ...options
});

/**
 * Récupérer l'inscription du participant courant à tous les événements
 */
export const meetingsEventsWithActivityMyEnrollmentsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityMyEnrollmentsListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityMyEnrollmentsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityMyEnrollmentsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityMyEnrollmentsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/my-enrollments/',
    ...options
});

/**
 * Liste les événements dont le participant actuel est responsable / en charge
 */
export const meetingsEventsWithActivityOwnPlanningList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityOwnPlanningListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityOwnPlanningListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityOwnPlanningListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityOwnPlanningListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/own-planning/',
    ...options
});

/**
 * Un "Event" correspond à un créneau temporel et un lien
 * pour un atelier d'une action de formation
 */
export const meetingsEventsWithActivityPlanningRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityPlanningRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityPlanningRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityPlanningRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsWithActivityPlanningRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/planning/',
    ...options
});

/**
 * Liste les événements du planning visibles pour l'utilisateur avec uniquement les attributs publics
 */
export const meetingsEventsWithActivityPublicListList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityPublicListListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityPublicListListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityPublicListListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityPublicListListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/public-list/',
    ...options
});

/**
 * Liste les événements futurs dont le participant est responsable
 */
export const meetingsEventsWithActivitySupervisorList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivitySupervisorListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivitySupervisorListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivitySupervisorListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivitySupervisorListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/supervisor/',
    ...options
});

/**
 * Liste événements de la journée type
 */
export const meetingsEventsWithActivityTypicalDayList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsWithActivityTypicalDayListData, ThrowOnError>): RequestResult<MeetingsEventsWithActivityTypicalDayListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsWithActivityTypicalDayListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsWithActivityTypicalDayListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events-with-activity/typical-day/',
    ...options
});

/**
 * Détruire un événement
 */
export const meetingsEventsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsDestroyData, ThrowOnError>): RequestResult<MeetingsEventsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/',
    ...options
});

/**
 * Récupérer les détails d'un événement
 */
export const meetingsEventsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/',
    ...options
});

/**
 * Mettre à jour un événement partiellement
 */
export const meetingsEventsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsEventsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsEventsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mettre à jour un événement
 */
export const meetingsEventsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsUpdateData, ThrowOnError>): RequestResult<MeetingsEventsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsEventsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lister les enfants d'un événement modulaire
 */
export const meetingsEventsChildrenRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsChildrenRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsChildrenRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsChildrenRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsChildrenRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/children/',
    ...options
});

/**
 * Créer un enfant d'un événement modulaire
 */
export const meetingsEventsChildrenCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsChildrenCreateData, ThrowOnError>): RequestResult<MeetingsEventsChildrenCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsChildrenCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsChildrenCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/children/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Applique l'événement sur les jours indiqués
 */
export const meetingsEventsCopyToDaysCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsCopyToDaysCreateData, ThrowOnError>): RequestResult<MeetingsEventsCopyToDaysCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsCopyToDaysCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsCopyToDaysCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/copy-to-days/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Désinscrire un participant à un événement
 */
export const meetingsEventsEnrollmentDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsEnrollmentDestroyData, ThrowOnError>): RequestResult<MeetingsEventsEnrollmentDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsEnrollmentDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/',
    ...options
});

/**
 * Récupérer l'inscription d'un participant a  un  evenement d'un meeting
 */
export const meetingsEventsEnrollmentList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsEnrollmentListData, ThrowOnError>): RequestResult<MeetingsEventsEnrollmentListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsEnrollmentListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsEnrollmentListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/',
    ...options
});

/**
 * Inscrire un participant à un événement
 */
export const meetingsEventsEnrollmentCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsEnrollmentCreateData, ThrowOnError>): RequestResult<MeetingsEventsEnrollmentCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsEnrollmentCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsEnrollmentCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exporte un événement au format iCalendar (.ics)
 */
export const meetingsEventsExportIcsRetrieve2 = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsExportIcsRetrieve2Data, ThrowOnError>): RequestResult<MeetingsEventsExportIcsRetrieve2Responses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsExportIcsRetrieve2Responses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/export-ics/',
    ...options
});

/**
 * Desinscrire le participant courant à un événement
 */
export const meetingsEventsMyEnrollmentDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsMyEnrollmentDestroyData, ThrowOnError>): RequestResult<MeetingsEventsMyEnrollmentDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsEventsMyEnrollmentDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/',
    ...options
});

/**
 * Récupérer l'inscription du participant courant à un événement
 */
export const meetingsEventsMyEnrollmentRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsMyEnrollmentRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsMyEnrollmentRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsMyEnrollmentRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsMyEnrollmentRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/',
    ...options
});

/**
 * Inscrire le participant courant à un événement
 */
export const meetingsEventsMyEnrollmentCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsMyEnrollmentCreateData, ThrowOnError>): RequestResult<MeetingsEventsMyEnrollmentCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsMyEnrollmentCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsMyEnrollmentCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/',
    ...options
});

/**
 * Applique la journée type sur les jours indiqués
 */
export const meetingsEventsApplyTypicalDayCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsApplyTypicalDayCreateData, ThrowOnError>): RequestResult<MeetingsEventsApplyTypicalDayCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsEventsApplyTypicalDayCreateResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsApplyTypicalDayCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/apply-typical-day/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupérer l'inscription d'un participant(s) aux evenements d'un meeting
 */
export const meetingsEventsEnrollmentsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsEnrollmentsListData, ThrowOnError>): RequestResult<MeetingsEventsEnrollmentsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsEnrollmentsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsEnrollmentsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/enrollments/',
    ...options
});

/**
 * Exporte le planning au format iCalendar (.ics)
 */
export const meetingsEventsExportIcsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsExportIcsRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsExportIcsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsExportIcsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/export-ics/',
    ...options
});

/**
 * Liste les événements futurs dont une équipe du participant est responsable
 */
export const meetingsEventsInChargeList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsInChargeListData, ThrowOnError>): RequestResult<MeetingsEventsInChargeListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsInChargeListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsInChargeListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/in-charge/',
    ...options
});

/**
 * Liste événements modulaires
 */
export const meetingsEventsModularList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsModularListData, ThrowOnError>): RequestResult<MeetingsEventsModularListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsModularListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsModularListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/modular/',
    ...options
});

/**
 * Liste les événements du jour pour le participant
 */
export const meetingsEventsMyDailyEventsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsMyDailyEventsListData, ThrowOnError>): RequestResult<MeetingsEventsMyDailyEventsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsMyDailyEventsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsMyDailyEventsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/my-daily-events/',
    ...options
});

/**
 * Récupérer l'inscription du participant courant à tous les événements
 */
export const meetingsEventsMyEnrollmentsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsMyEnrollmentsListData, ThrowOnError>): RequestResult<MeetingsEventsMyEnrollmentsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsMyEnrollmentsListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsMyEnrollmentsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/my-enrollments/',
    ...options
});

/**
 * Liste les événements dont le participant actuel est responsable / en charge
 */
export const meetingsEventsOwnPlanningList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsOwnPlanningListData, ThrowOnError>): RequestResult<MeetingsEventsOwnPlanningListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsOwnPlanningListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsOwnPlanningListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/own-planning/',
    ...options
});

/**
 * Un "Event" correspond à un créneau temporel et un lien
 * pour un atelier d'une action de formation
 */
export const meetingsEventsPlanningRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsPlanningRetrieveData, ThrowOnError>): RequestResult<MeetingsEventsPlanningRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsPlanningRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsEventsPlanningRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/planning/',
    ...options
});

/**
 * Liste les événements du planning visibles pour l'utilisateur avec uniquement les attributs publics
 */
export const meetingsEventsPublicListList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsPublicListListData, ThrowOnError>): RequestResult<MeetingsEventsPublicListListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsPublicListListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsPublicListListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/public-list/',
    ...options
});

/**
 * Liste événements modulaires publiques
 */
export const meetingsEventsPublicModularList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsPublicModularListData, ThrowOnError>): RequestResult<MeetingsEventsPublicModularListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsPublicModularListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsPublicModularListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/public-modular/',
    ...options
});

/**
 * Liste les événements futurs dont le participant est responsable
 */
export const meetingsEventsSupervisorList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsSupervisorListData, ThrowOnError>): RequestResult<MeetingsEventsSupervisorListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsSupervisorListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsSupervisorListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/supervisor/',
    ...options
});

/**
 * Liste événements de la journée type
 */
export const meetingsEventsTypicalDayList = <ThrowOnError extends boolean = false>(options: Options<MeetingsEventsTypicalDayListData, ThrowOnError>): RequestResult<MeetingsEventsTypicalDayListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsEventsTypicalDayListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { event_type__in: { array: { explode: false } } } },
    responseTransformer: meetingsEventsTypicalDayListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/events/typical-day/',
    ...options
});

/**
 * List the exports available for a meeting
 */
export const meetingsExportsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsExportsListData, ThrowOnError>): RequestResult<MeetingsExportsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsExportsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/exports/',
    ...options
});

/**
 * Retrieve an export for a meeting
 */
export const meetingsExportsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsExportsRetrieveData, ThrowOnError>): RequestResult<MeetingsExportsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsExportsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/exports/{id}/',
    ...options
});

/**
 * This viewset provides `list`, `retrieve` for a specified meeting actions.
 */
export const meetingsExportsExportRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsExportsExportRetrieveData, ThrowOnError>): RequestResult<MeetingsExportsExportRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsExportsExportRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/exports/{id}/export/',
    ...options
});

export const meetingsFormsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsListData, ThrowOnError>): RequestResult<MeetingsFormsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsCreateData, ThrowOnError>): RequestResult<MeetingsFormsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsFormsPublicList = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsPublicListData, ThrowOnError>): RequestResult<MeetingsFormsPublicListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsPublicListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsPublicListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms-public/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsPublicRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsPublicRetrieveData, ThrowOnError>): RequestResult<MeetingsFormsPublicRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsPublicRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsPublicRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms-public/{id}/',
    ...options
});

export const meetingsFormsFieldsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsListData, ThrowOnError>): RequestResult<MeetingsFormsFieldsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsFieldsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsFieldsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsCreateData, ThrowOnError>): RequestResult<MeetingsFormsFieldsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsFieldsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsFormsFieldsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsDestroyData, ThrowOnError>): RequestResult<MeetingsFormsFieldsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsFormsFieldsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsFieldsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsRetrieveData, ThrowOnError>): RequestResult<MeetingsFormsFieldsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsFieldsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsFieldsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsFormsFieldsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsFormsFieldsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsFormsFieldsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsFieldsUpdateData, ThrowOnError>): RequestResult<MeetingsFormsFieldsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsFormsFieldsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsFormsSubmissionsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsListData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsSubmissionsListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsSubmissionsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsSubmissionsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsCreateData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsSubmissionsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsSubmissionsCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsFormsSubmissionsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsDestroyData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsFormsSubmissionsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsSubmissionsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsRetrieveData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsSubmissionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsSubmissionsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsSubmissionsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsFormsSubmissionsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsSubmissionsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsFormsSubmissionsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsSubmissionsUpdateData, ThrowOnError>): RequestResult<MeetingsFormsSubmissionsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsFormsSubmissionsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsSubmissionsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsFormsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsDestroyData, ThrowOnError>): RequestResult<MeetingsFormsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsFormsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsRetrieveData, ThrowOnError>): RequestResult<MeetingsFormsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsFormsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsFormsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsFormsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsFormsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsUpdateData, ThrowOnError>): RequestResult<MeetingsFormsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsFormsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dupliquer un formulaire
 */
export const meetingsFormsDuplicateCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsDuplicateCreateData, ThrowOnError>): RequestResult<MeetingsFormsDuplicateCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsDuplicateCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/duplicate/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exporter les réponses du formulaire en CSV ou XLSX (format=csv ou format=xlsx)
 */
export const meetingsFormsExportSubmissionsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsExportSubmissionsRetrieveData, ThrowOnError>): RequestResult<MeetingsFormsExportSubmissionsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsFormsExportSubmissionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsExportSubmissionsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/export-submissions/',
    ...options
});

/**
 * Publier un formulaire
 */
export const meetingsFormsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsPublishCreateData, ThrowOnError>): RequestResult<MeetingsFormsPublishCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsPublishCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsFormsPublishCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/publish/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dépublier un formulaire
 */
export const meetingsFormsUnpublishCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsFormsUnpublishCreateData, ThrowOnError>): RequestResult<MeetingsFormsUnpublishCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsFormsUnpublishCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/forms/{id}/unpublish/',
    ...options
});

export const meetingsInfoCampaignList = <ThrowOnError extends boolean = false>(options: Options<MeetingsInfoCampaignListData, ThrowOnError>): RequestResult<MeetingsInfoCampaignListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsInfoCampaignListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/info-campaign/',
    ...options
});

export const meetingsInfoCampaignCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsInfoCampaignCreateData, ThrowOnError>): RequestResult<MeetingsInfoCampaignCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsInfoCampaignCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/info-campaign/',
    ...options
});

export const meetingsInfoCampaignPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsInfoCampaignPartialUpdateData, ThrowOnError>): RequestResult<MeetingsInfoCampaignPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsInfoCampaignPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/info-campaign/{id}/',
    ...options
});

export const meetingsInfoCampaignUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsInfoCampaignUpdateData, ThrowOnError>): RequestResult<MeetingsInfoCampaignUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsInfoCampaignUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/info-campaign/{id}/',
    ...options
});

/**
 * Toggle module activation
 *
 * Enable or disable a module for the specified meeting
 */
export const meetingsModulesToggleCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsModulesToggleCreateData, ThrowOnError>): RequestResult<MeetingsModulesToggleCreateResponses, MeetingsModulesToggleCreateErrors, ThrowOnError> => (options.client ?? client).post<MeetingsModulesToggleCreateResponses, MeetingsModulesToggleCreateErrors, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/modules/{module_id}/toggle/',
    ...options
});

/**
 * Liste tous les participants d'une action de formation où je suis directeur/formateur
 */
export const meetingsParticipantsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsListData, ThrowOnError>): RequestResult<MeetingsParticipantsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/',
    ...options
});

/**
 * Récupère un participant par uuid
 */
export const meetingsParticipantsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsRetrieveData, ThrowOnError>): RequestResult<MeetingsParticipantsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/',
    ...options
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsParticipantsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsParticipantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsAvatarMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsAvatarMediaRetrieveData, ThrowOnError>): RequestResult<MeetingsParticipantsAvatarMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsAvatarMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsAvatarMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/avatar-media/',
    ...options
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsAvatarMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsAvatarMediaUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsAvatarMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsParticipantsAvatarMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: meetingsParticipantsAvatarMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/avatar-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Récupère les avis d'un participants
 */
export const meetingsParticipantsOpinionRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsOpinionRetrieveData, ThrowOnError>): RequestResult<MeetingsParticipantsOpinionRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsOpinionRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsOpinionRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/',
    ...options
});

/**
 * Change les avis d'un participant
 */
export const meetingsParticipantsOpinionPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsOpinionPartialUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsOpinionPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsParticipantsOpinionPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsOpinionPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change les avis d'un participant
 */
export const meetingsParticipantsOpinionUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsOpinionUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsOpinionUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsParticipantsOpinionUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsOpinionUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprimer l'avatar enregistrée
 */
export const meetingsParticipantsResetAvatarDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsResetAvatarDestroyData, ThrowOnError>): RequestResult<MeetingsParticipantsResetAvatarDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsParticipantsResetAvatarDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/reset-avatar/',
    ...options
});

/**
 * Supprimer la signature enregistrée
 */
export const meetingsParticipantsResetSignatureDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsResetSignatureDestroyData, ThrowOnError>): RequestResult<MeetingsParticipantsResetSignatureDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsParticipantsResetSignatureDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/reset-signature/',
    ...options
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsSignatureMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsSignatureMediaRetrieveData, ThrowOnError>): RequestResult<MeetingsParticipantsSignatureMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsSignatureMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsSignatureMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/signature-media/',
    ...options
});

/**
 * Un "MeetingParticipant" correspond à une inscription à
 * une action de formation ou d'événement (Meeting)
 */
export const meetingsParticipantsSignatureMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsSignatureMediaUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsSignatureMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsParticipantsSignatureMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: meetingsParticipantsSignatureMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{id}/signature-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List all comments for a single participant for a single meeting
 */
export const meetingsParticipantsCommentsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsListData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsCommentsListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsCommentsListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/',
    ...options
});

/**
 * Create a new comment for a participant in a meeting
 */
export const meetingsParticipantsCommentsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsCreateData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsParticipantsCommentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsCommentsCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a comment for a participant
 */
export const meetingsParticipantsCommentsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsDestroyData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsParticipantsCommentsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/',
    ...options
});

/**
 * Get a single comment for a participant
 */
export const meetingsParticipantsCommentsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsRetrieveData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsCommentsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsCommentsRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/',
    ...options
});

/**
 * Partially update a comment for a participant
 */
export const meetingsParticipantsCommentsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsParticipantsCommentsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsCommentsPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a comment for a participant
 */
export const meetingsParticipantsCommentsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsCommentsUpdateData, ThrowOnError>): RequestResult<MeetingsParticipantsCommentsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsParticipantsCommentsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsCommentsUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupère la liste des participants ainsi que leurs avis
 */
export const meetingsParticipantsOpinionListList = <ThrowOnError extends boolean = false>(options: Options<MeetingsParticipantsOpinionListListData, ThrowOnError>): RequestResult<MeetingsParticipantsOpinionListListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsParticipantsOpinionListListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsParticipantsOpinionListListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/participants/opinion-list/',
    ...options
});

/**
 * TODO
 */
export const meetingsResourcesCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesCreateData, ThrowOnError>): RequestResult<MeetingsResourcesCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsResourcesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsResourcesPublicCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicCreateData, ThrowOnError>): RequestResult<MeetingsResourcesPublicCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsResourcesPublicCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsResourcesPublicRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesPublicRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesPublicRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsResourcesPublicPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicPartialUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesPublicPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsResourcesPublicPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsResourcesPublicUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesPublicUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsResourcesPublicUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsResourcesPublicResourceMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicResourceMediaRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesPublicResourceMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesPublicResourceMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicResourceMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/{id}/resource-media/',
    ...options
});

export const meetingsResourcesPublicResourceMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicResourceMediaUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesPublicResourceMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsResourcesPublicResourceMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: meetingsResourcesPublicResourceMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/{id}/resource-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const meetingsResourcesPublicTreeRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPublicTreeRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesPublicTreeRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesPublicTreeRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPublicTreeRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources-public/tree/',
    ...options
});

export const meetingsResourcesDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesDestroyData, ThrowOnError>): RequestResult<MeetingsResourcesDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsResourcesDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsResourcesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsResourcesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesPartialUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsResourcesPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsResourcesUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsResourcesUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsResourcesResourceMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesResourceMediaRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesResourceMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesResourceMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesResourceMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/resource-media/',
    ...options
});

export const meetingsResourcesResourceMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesResourceMediaUpdateData, ThrowOnError>): RequestResult<MeetingsResourcesResourceMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsResourcesResourceMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: meetingsResourcesResourceMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/{id}/resource-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const meetingsResourcesTreeRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesTreeRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesTreeRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesTreeRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsResourcesTreeRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/tree/',
    ...options
});

/**
 * list of placeholders allowed in url_template field
 */
export const meetingsResourcesUrlTemplatePlaceholdersRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsResourcesUrlTemplatePlaceholdersRetrieveData, ThrowOnError>): RequestResult<MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/resources/url-template-placeholders/',
    ...options
});

/**
 * Liste les salles associées à un 'meeting'
 */
export const meetingsRoomsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsListData, ThrowOnError>): RequestResult<MeetingsRoomsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsRoomsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/',
    ...options
});

/**
 * Crée une nouvelle salle
 */
export const meetingsRoomsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsCreateData, ThrowOnError>): RequestResult<MeetingsRoomsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsRoomsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprime une salle
 */
export const meetingsRoomsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsDestroyData, ThrowOnError>): RequestResult<MeetingsRoomsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsRoomsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/{id}/',
    ...options
});

/**
 * Détaille une salle
 */
export const meetingsRoomsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsRetrieveData, ThrowOnError>): RequestResult<MeetingsRoomsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsRoomsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/{id}/',
    ...options
});

/**
 * Modifie partiellement une salle
 */
export const meetingsRoomsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsRoomsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsRoomsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modifie une salle
 */
export const meetingsRoomsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsRoomsUpdateData, ThrowOnError>): RequestResult<MeetingsRoomsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsRoomsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/rooms/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const meetingsTableExportsParticipantEnrollementsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsParticipantEnrollementsRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsParticipantEnrollementsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsParticipantEnrollementsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/participant-enrollements/',
    ...options
});

export const meetingsTableExportsParticipantListRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsParticipantListRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsParticipantListRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsParticipantListRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTableExportsParticipantListRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/participant-list/',
    ...options
});

export const meetingsTableExportsParticipantListDirectionRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsParticipantListDirectionRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsParticipantListDirectionRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsParticipantListDirectionRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTableExportsParticipantListDirectionRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/participant-list-direction/',
    ...options
});

export const meetingsTableExportsProcesVerbalRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsProcesVerbalRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsProcesVerbalRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsProcesVerbalRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTableExportsProcesVerbalRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/proces-verbal/',
    ...options
});

export const meetingsTableExportsTeamsdailytasksbytaskRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsTeamsdailytasksbytaskRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTableExportsTeamsdailytasksbytaskRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/teamsdailytasksbytask/',
    ...options
});

export const meetingsTableExportsTeamsdailytasksbyteamRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTableExportsTeamsdailytasksbyteamRetrieveData, ThrowOnError>): RequestResult<MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTableExportsTeamsdailytasksbyteamRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/table-exports/teamsdailytasksbyteam/',
    ...options
});

/**
 * Retourne la liste des Services assignes à une Equipe
 */
export const meetingsTeamDailyTasksList = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksListData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamDailyTasksListResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTeamDailyTasksListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/',
    ...options
});

/**
 * Crée une tache de Service pour une Equipe
 */
export const meetingsTeamDailyTasksCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksCreateData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsTeamDailyTasksCreateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTeamDailyTasksCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprime une instance de Service d'Equipe via son ID
 */
export const meetingsTeamDailyTasksDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksDestroyData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsTeamDailyTasksDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/',
    ...options
});

/**
 * Récupère les informations d'une instance de Service assigné à une Equipe via son ID.
 */
export const meetingsTeamDailyTasksRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksRetrieveData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamDailyTasksRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTeamDailyTasksRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/',
    ...options
});

/**
 * Patch une instance de Service d'Equipe via son ID
 */
export const meetingsTeamDailyTasksPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksPartialUpdateData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsTeamDailyTasksPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTeamDailyTasksPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modifie une instance de Service d'Equipe via son ID
 */
export const meetingsTeamDailyTasksUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamDailyTasksUpdateData, ThrowOnError>): RequestResult<MeetingsTeamDailyTasksUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsTeamDailyTasksUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: meetingsTeamDailyTasksUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the teams for the meeting
 */
export const meetingsTeamsList = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsListData, ThrowOnError>): RequestResult<MeetingsTeamsListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/',
    ...options
});

/**
 * Create a new team for the meeting
 */
export const meetingsTeamsCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCreateData, ThrowOnError>): RequestResult<MeetingsTeamsCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsTeamsCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesList = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesListData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamsCategoriesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/',
    ...options
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesCreateData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsTeamsCategoriesCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesDestroyData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsTeamsCategoriesDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesRetrieveData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamsCategoriesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/',
    ...options
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesPartialUpdateData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsTeamsCategoriesPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * TODO
 */
export const meetingsTeamsCategoriesUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsCategoriesUpdateData, ThrowOnError>): RequestResult<MeetingsTeamsCategoriesUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsTeamsCategoriesUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a team
 */
export const meetingsTeamsDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsDestroyData, ThrowOnError>): RequestResult<MeetingsTeamsDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsTeamsDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/',
    ...options
});

/**
 * Retrieve a single team from the meeting
 */
export const meetingsTeamsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsRetrieveData, ThrowOnError>): RequestResult<MeetingsTeamsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/',
    ...options
});

/**
 * Partially update a single team
 */
export const meetingsTeamsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsPartialUpdateData, ThrowOnError>): RequestResult<MeetingsTeamsPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsTeamsPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a single team
 */
export const meetingsTeamsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsUpdateData, ThrowOnError>): RequestResult<MeetingsTeamsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsTeamsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of MeetingParticipants associated to a Team
 */
export const meetingsTeamsParticipantsRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsParticipantsRetrieveData, ThrowOnError>): RequestResult<MeetingsTeamsParticipantsRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTeamsParticipantsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/participants/',
    ...options
});

/**
 * Update the list of MeetingParticipants associated to a Team
 * Only MeetingParticipant of this list will be assigned
 */
export const meetingsTeamsParticipantsUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTeamsParticipantsUpdateData, ThrowOnError>): RequestResult<MeetingsTeamsParticipantsUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsTeamsParticipantsUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/teams/{id}/participants/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liste les différents parcours de formation pour un meeting. Un"track" est un parcours de formation au choix dans un 'meeting' (tel que Appro AS, Appro Anim)
 */
export const meetingsTracksList = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksListData, ThrowOnError>): RequestResult<MeetingsTracksListResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTracksListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/',
    ...options
});

/**
 * Crée un nouveau parcours de formation
 */
export const meetingsTracksCreate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksCreateData, ThrowOnError>): RequestResult<MeetingsTracksCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<MeetingsTracksCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Supprime le parcours de formation
 */
export const meetingsTracksDestroy = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksDestroyData, ThrowOnError>): RequestResult<MeetingsTracksDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<MeetingsTracksDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/{id}/',
    ...options
});

/**
 * Détaille un parcours de formation spécifique
 */
export const meetingsTracksRetrieve = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksRetrieveData, ThrowOnError>): RequestResult<MeetingsTracksRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<MeetingsTracksRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/{id}/',
    ...options
});

/**
 * Modifie partiellement le parcours de formation
 */
export const meetingsTracksPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksPartialUpdateData, ThrowOnError>): RequestResult<MeetingsTracksPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<MeetingsTracksPartialUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modifie le parcours de formation
 */
export const meetingsTracksUpdate = <ThrowOnError extends boolean = false>(options: Options<MeetingsTracksUpdateData, ThrowOnError>): RequestResult<MeetingsTracksUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<MeetingsTracksUpdateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/meetings/{meeting_id}/tracks/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const participantsExportsProcesVerbalRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ParticipantsExportsProcesVerbalRetrieveData, ThrowOnError>): RequestResult<ParticipantsExportsProcesVerbalRetrieveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ParticipantsExportsProcesVerbalRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: participantsExportsProcesVerbalRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/participants-exports/proces-verbal/',
    ...options
});

/**
 * Un "Place" correspond à un lieu d'action de formation ou d'événement
 */
export const placesList = <ThrowOnError extends boolean = false>(options?: Options<PlacesListData, ThrowOnError>): RequestResult<PlacesListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PlacesListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/places/',
    ...options
});

/**
 * Un "Place" correspond à un lieu d'action de formation ou d'événement
 */
export const placesRetrieve = <ThrowOnError extends boolean = false>(options: Options<PlacesRetrieveData, ThrowOnError>): RequestResult<PlacesRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<PlacesRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/places/{id}/',
    ...options
});

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = <ThrowOnError extends boolean = false>(options?: Options<SchemaRetrieveData, ThrowOnError>): RequestResult<SchemaRetrieveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/schema/',
    ...options
});

/**
 * List of structure with participants
 */
export const structureExportsList = <ThrowOnError extends boolean = false>(options?: Options<StructureExportsListData, ThrowOnError>): RequestResult<StructureExportsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StructureExportsListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structure-exports/',
    ...options
});

/**
 * Exports le document liés à des participants d'une structure
 */
export const structureExportsExportRetrieve = <ThrowOnError extends boolean = false>(options: Options<StructureExportsExportRetrieveData, ThrowOnError>): RequestResult<StructureExportsExportRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<StructureExportsExportRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structure-exports/{structure_id}/export/',
    ...options
});

/**
 * Liste des groupes avec participants associés
 */
export const structureExportsListByGroupeList = <ThrowOnError extends boolean = false>(options?: Options<StructureExportsListByGroupeListData, ThrowOnError>): RequestResult<StructureExportsListByGroupeListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StructureExportsListByGroupeListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structure-exports/list-by-groupe/',
    ...options
});

/**
 * Liste des territoire avec participants associés
 */
export const structureExportsListByTerritoireList = <ThrowOnError extends boolean = false>(options?: Options<StructureExportsListByTerritoireListData, ThrowOnError>): RequestResult<StructureExportsListByTerritoireListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StructureExportsListByTerritoireListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structure-exports/list-by-territoire/',
    ...options
});

/**
 * Liste les centres de ressources, pour deslistes déroulantes par exemple
 */
export const structuresCentresRessourceList = <ThrowOnError extends boolean = false>(options?: Options<StructuresCentresRessourceListData, ThrowOnError>): RequestResult<StructuresCentresRessourceListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StructuresCentresRessourceListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structures/centres-ressource/',
    ...options
});

/**
 * Liste les structures organisatrices de stage, pour deslistes déroulantes par exemple
 */
export const structuresOrganisatriceList = <ThrowOnError extends boolean = false>(options?: Options<StructuresOrganisatriceListData, ThrowOnError>): RequestResult<StructuresOrganisatriceListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StructuresOrganisatriceListResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/structures/organisatrice/',
    ...options
});

/**
 * When the user accept the Déontologie, please call this route
 */
export const usersDeontologieEnableCreate = <ThrowOnError extends boolean = false>(options?: Options<UsersDeontologieEnableCreateData, ThrowOnError>): RequestResult<UsersDeontologieEnableCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UsersDeontologieEnableCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users-deontologie/enable/',
    ...options
});

/**
 * La liste des utilisateurs
 */
export const usersRetrieve = <ThrowOnError extends boolean = false>(options: Options<UsersRetrieveData, ThrowOnError>): RequestResult<UsersRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/',
    ...options
});

/**
 * La liste des utilisateurs
 */
export const usersAvatarMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<UsersAvatarMediaRetrieveData, ThrowOnError>): RequestResult<UsersAvatarMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersAvatarMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersAvatarMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/avatar-media/',
    ...options
});

/**
 * La liste des utilisateurs
 */
export const usersAvatarMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersAvatarMediaUpdateData, ThrowOnError>): RequestResult<UsersAvatarMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<UsersAvatarMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: usersAvatarMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/avatar-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Supprimer l'avatar enregistrée
 */
export const usersResetAvatarDestroy = <ThrowOnError extends boolean = false>(options: Options<UsersResetAvatarDestroyData, ThrowOnError>): RequestResult<UsersResetAvatarDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersResetAvatarDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/reset-avatar/',
    ...options
});

/**
 * Supprimer la signature enregistrée
 */
export const usersResetSignatureDestroy = <ThrowOnError extends boolean = false>(options: Options<UsersResetSignatureDestroyData, ThrowOnError>): RequestResult<UsersResetSignatureDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersResetSignatureDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/reset-signature/',
    ...options
});

/**
 * La liste des utilisateurs
 */
export const usersSignatureMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<UsersSignatureMediaRetrieveData, ThrowOnError>): RequestResult<UsersSignatureMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersSignatureMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersSignatureMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/signature-media/',
    ...options
});

/**
 * La liste des utilisateurs
 */
export const usersSignatureMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersSignatureMediaUpdateData, ThrowOnError>): RequestResult<UsersSignatureMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<UsersSignatureMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: usersSignatureMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{id}/signature-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List diplomas of the user
 */
export const usersDiplomasList = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasListData, ThrowOnError>): RequestResult<UsersDiplomasListResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersDiplomasListResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasListResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/',
    ...options
});

/**
 * Create a new diploma for the user
 */
export const usersDiplomasCreate = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasCreateData, ThrowOnError>): RequestResult<UsersDiplomasCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersDiplomasCreateResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a diploma
 */
export const usersDiplomasDestroy = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasDestroyData, ThrowOnError>): RequestResult<UsersDiplomasDestroyResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersDiplomasDestroyResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/',
    ...options
});

/**
 * Retrieve a diploma team from the user
 */
export const usersDiplomasRetrieve = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasRetrieveData, ThrowOnError>): RequestResult<UsersDiplomasRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersDiplomasRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/',
    ...options
});

/**
 * Partially update a diploma
 */
export const usersDiplomasPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasPartialUpdateData, ThrowOnError>): RequestResult<UsersDiplomasPartialUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersDiplomasPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasPartialUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a diploma
 */
export const usersDiplomasUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasUpdateData, ThrowOnError>): RequestResult<UsersDiplomasUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<UsersDiplomasUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const usersDiplomasDiplomaMediaRetrieve = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasDiplomaMediaRetrieveData, ThrowOnError>): RequestResult<UsersDiplomasDiplomaMediaRetrieveResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersDiplomasDiplomaMediaRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersDiplomasDiplomaMediaRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/diploma-media/',
    ...options
});

export const usersDiplomasDiplomaMediaUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersDiplomasDiplomaMediaUpdateData, ThrowOnError>): RequestResult<UsersDiplomasDiplomaMediaUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<UsersDiplomasDiplomaMediaUpdateResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseTransformer: usersDiplomasDiplomaMediaUpdateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{user_id}/diplomas/{id}/diploma-media/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Récupère les droits d'accès de l'utilisateur courant
 */
export const usersAccessRightsRetrieve = <ThrowOnError extends boolean = false>(options?: Options<UsersAccessRightsRetrieveData, ThrowOnError>): RequestResult<UsersAccessRightsRetrieveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersAccessRightsRetrieveResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/access-rights/',
    ...options
});

/**
 * Récupère les informations sur l'utilisateur courant
 */
export const usersMeRetrieve = <ThrowOnError extends boolean = false>(options?: Options<UsersMeRetrieveData, ThrowOnError>): RequestResult<UsersMeRetrieveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersMeRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: usersMeRetrieveResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/users/me/',
    ...options
});

/**
 * Cron Endpoint
 * Synchronise toutes les formations
 * Ne synchronise pas les participants (synchroniser une formation à la fois pour les participants)
 */
export const webhooksCronMeetingCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhooksCronMeetingCreateData, ThrowOnError>): RequestResult<WebhooksCronMeetingCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WebhooksCronMeetingCreateResponses, unknown, ThrowOnError>({
    responseTransformer: webhooksCronMeetingCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/cron/meeting/',
    ...options
});

/**
 * Synchronise tous les Participants de toutes les formations
 */
export const webhooksCronMeetingParticipantCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhooksCronMeetingParticipantCreateData, ThrowOnError>): RequestResult<WebhooksCronMeetingParticipantCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WebhooksCronMeetingParticipantCreateResponses, unknown, ThrowOnError>({
    responseTransformer: webhooksCronMeetingParticipantCreateResponseTransformer,
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/cron/meeting-participant/',
    ...options
});

/**
 * Cron Endpoint
 * Synchronise toutes les types de formation
 */
export const webhooksCronMeetingTypeCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhooksCronMeetingTypeCreateData, ThrowOnError>): RequestResult<WebhooksCronMeetingTypeCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WebhooksCronMeetingTypeCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/cron/meeting-type/',
    ...options
});

/**
 * Synchronise toutes les lieux de formations
 */
export const webhooksCronPlaceCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhooksCronPlaceCreateData, ThrowOnError>): RequestResult<WebhooksCronPlaceCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WebhooksCronPlaceCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/cron/place/',
    ...options
});

/**
 * Synchronise toutes les structures Intranet
 */
export const webhooksCronStructureCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhooksCronStructureCreateData, ThrowOnError>): RequestResult<WebhooksCronStructureCreateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WebhooksCronStructureCreateResponses, unknown, ThrowOnError>({
    security: [
        {
            key: 'qrCodeTokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'jwtAuth',
            name: 'Authorization',
            type: 'apiKey'
        },
        {
            key: 'tokenAuth',
            name: 'Authorization',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/cron/structure/',
    ...options
});
